/* eslint-disable react/jsx-key */
/*
 * @Author: liyxt
 * @Date: 2019-08-27 16:34:44
 * @LastEditors: bbqin
 * @LastEditTime: 2022-12-12 11:29:12
 * @Description: file content
 */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable max-lines */
/* eslint-disable no-cond-assign */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-empty */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import React from 'react';
import ReactDOM from 'react-dom';
// 第三方库
import { HotKeys } from 'react-hotkeys';
import { Resizable } from 're-resizable';
import classNames from 'classnames';
// base
import FormControl from 'bee-form-control';
// import Loading from '../Loading';
import Collapse from '../Collapse';
import NCTable from '../Table';
import Row from '../Row';
import Checkbox from '../Checkbox';
import Button from '../Button';
import Popover from '../Popover';
import Pagination from '../Pagination';
import Dnd from '../Dnd';
import Tabs from '../Tabs';
import Menu from '../Menu';
import NCHotKeys from '../HotKeys';
import Tooltip from '../Tooltip';
import Selectable from '../Selectable';
import Dropdown from '../Dropdown';
// components
import ArrayTree from './components/ArrayTree';
import sortTable from './components/sortTable';
import Loading from './components/ReferLoading';
// api
import { toast, ajax, getSysFieldid, pageTo } from '@platform/api';
import BaseRefer from './BaseRefer';
import { getGlobalStorage } from '@platform/api'
// drag

import DragWidthCom from '../../components/DragWidthCom';
// util
import {
    resizeOnVertical,
    calculateMinWidth,
    getUniqueClass,
    setContainerStyle,
    modalAlwaysShowInView,
    calculateResizeContainerHeight,
    clearDomReference,
    executePopOverEnterSelect,
    dealTreeFocusItem,
    countTitle,
    perceptionRowIndexWithUp,
    focusToTableHeadCheckBox,
    selectToLastRow,
    selectToFirstRow,
    perceptionRowIndexWithDown,
} from './utils';

//常量
import {
    CONTAINER_DEFAULT_MIN_HEIGHT,
    REFER_CONTENT_AREA_HEIGHT,
    PADDING_LEFT_IN_MAX_STATUS,
    PADDING_TOP_IN_MAX_STATUS,
    GRID_TREE_SEARCH_INPUT,
    TABLE_HEAD_CHECKBOX_CLASS_NAME,
} from './constants';

//common methods
import { findParentTd } from '@platform/api';
import { isIE } from '@platform/api';

//
const { TabPane: TabPane } = Tabs,
    { SubMenu: SubMenu, Item } = Menu;

const SAVE_USUAL_URL = '/nccloud/uapbd/refer/SaveUsualAction.do';
const DELETE_USUAL_URL = '/nccloud/uapbd/refer/DeleteUsualAction.do';

const tableRowHeight = 28;

// import 'bee-menus/build/Menu.css';

const Table = sortTable(NCTable);

function isUndefined(value) {
    return value === undefined;
}

export default class Refer extends BaseRefer {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            searchVal: '', // 搜索框的value
            treeSearchVal: '', // 树搜索框的value
            isFirstShow: true, // 模态框是否是第一次显示
            selectedShow: false, // 已选择是否显示
            selectedKeys: [], // 选择的树节点
            expandedKeys: [props.rootNode[props.idKey]], // 展开的树节点
            isSearch: false, // 是否是表格搜索
            isTreeSearch: false, // 是否是树搜索
            columnConfig: this.getColumnConfig(), // 列设置
            activeKey: '2', // 常用 or 全部 页签
            includeChildren: props.defaultIncludeChildren || false, // 是否包含下级
            runWithChildren: props.defaultRunWithChildren || false, // 执行时包含下级
            isShowDisabledData: false, // 是否显示停用
            max: props.defaultMax, // 是否是最大化状态
            isExpandLeftArea: false, // 是否展开左侧区域
            tableScrollHeight: 0, // 表格滚动区域
            isMultiSelectMode: false, // 是否是多选模式
            isDisabledDataDisabled: false, // 显示停用框是否禁用
            selectedRowIndex: -1, // 表格选中行的index
            keyMap: {}, // 树数据key的map结构
            resizeHeight: 0, // 更改的高度
            referContentAreaHeight: REFER_CONTENT_AREA_HEIGHT, //内容的高度
            dragStartPosition: {
                x: 0,
                y: 0,
            }, // 拖拽开始位置
            resizePosition: {
                x: 0,
                y: 0,
            }, //窗口改变大小位置
            addButtonList: null, // 新增按钮列表
            isAddButtonShow: false, // 新增按钮下拉是否显示
            currentButtonIndex: 0, // 当前选择的新增按钮（快捷键）
            selectLevel: [1, 1], // 级次选择的值
        };
        this.hotKeyElement = {
            referPopWindow: Symbol('referPopWindow'),
            tableSearchInput: Symbol('tableSearchInput'),
            treeSearchInput: Symbol('treeSearchInput'),
            showDisabledData: Symbol('showDisabledData'),
            includeChildren: Symbol('includeChildren'),
            referTable: Symbol('referTable'),
            runWithChildren: Symbol('runWithChildren'),
            referTree: Symbol('referTree'),
            unit: Symbol('unit'),
            tabs: Symbol('tabs'),
            moreButton: Symbol('moreButton'),
        };
        this.tree = new Map(
            [
                this.hotKeyElement.referPopWindow,
                this.hotKeyElement.referTree,
                this.hotKeyElement.runWithChildren, // 可能没有
                this.hotKeyElement.unit, // 可能没有
                this.hotKeyElement.treeSearchInput,
                this.hotKeyElement.showDisabledData,
                this.hotKeyElement.includeChildren,
                this.hotKeyElement.moreButton, // 一定有
            ]
                .filter(e => e)
                .map((e, i) => [e, i]),
        );
        this.grid = new Map(
            [
                this.hotKeyElement.referPopWindow,
                this.hotKeyElement.referTable,
                this.hotKeyElement.unit, // 可能没有
                this.hotKeyElement.tableSearchInput, // 一定有
                this.hotKeyElement.showDisabledData, // 可能没有
            ]
                .filter(e => e)
                .map((e, i) => [e, i]),
        );
        this.gridTree = new Map(
            [
                this.hotKeyElement.referPopWindow,
                this.hotKeyElement.referTree,
                this.hotKeyElement.tableSearchInput,
                this.hotKeyElement.showDisabledData, // 可能没有
                this.hotKeyElement.referTable,
                this.hotKeyElement.unit, // 可能没有
                this.hotKeyElement.treeSearchInput, // 一定有
            ]
                .filter(e => e)
                .map((e, i) => [e, i]),
        );
        this.usual = new Map(
            [
                this.hotKeyElement.referPopWindow,
                this.hotKeyElement.referTable,
                this.hotKeyElement.unit,
                this.hotKeyElement.tableSearchInput, // 一定有
                this.hotKeyElement.showDisabledData, // 可能没有
            ]
                .filter(e => e)
                .map((e, i) => [e, i]),
        );

        this.onResize = this.onResize.bind(this);
        this.onResizeStop = this.onResizeStop.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.timer = null;
    }

    componentDidMount() {
        super.componentDidMount();
        document.addEventListener('keypress', this.handleKeyPress);
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        //防止内存泄漏，删除dom引用
        let domList = [
            'referInput',
            'popWindow',
            'popover',
            'loadingContainer',
            'searchTableInput',
            'disableDataCheckbox',
            'moreButtonMenu',
            'table',
            'referTable',
            'refTree',
            'searchTreeInput',
            'hotKeyElement',
            'usual',
            'gridTree',
            'tree',
            'gird',
            'referSearchDom',
        ];
        clearDomReference(this, domList);

        this.lifecycleStatus = 'unmount';
        document.removeEventListener('keypress', this.handleKeyPress);
    }

	handleKeyPress = e => {
	    this.spaceKeyPress = e.charCode === 32;
	};

	// 表格的按键事件
	onTableKeyPress = (up = false) => {
	    let { selectedRowIndex, tableData } = this.state,
	        { isMultiSelectedEnabled } = this.props,
	        len = tableData[0].rows.length - 1,
	        tableBody = this.table && this.table.querySelector('.u-table-scroll .u-table-body');

	    if (document.activeElement === this.table) {
	        if (up) {
	            // up键
	            if (selectedRowIndex == 0) {
	                selectedRowIndex = perceptionRowIndexWithUp(selectedRowIndex, isMultiSelectedEnabled);

	                selectedRowIndex === -1 && focusToTableHeadCheckBox(this.table, this.spaceKeyDown);
	                // 处理焦点行超出视口时的scrollTop
	                this.scrollTop = selectedRowIndex * tableRowHeight;
	            } else {
	                selectedRowIndex--;
	                // 处理焦点行超出视口时的scrollTop
	                if (tableBody && selectedRowIndex * tableRowHeight < tableBody.scrollTop) {
	                    this.scrollTop = selectedRowIndex * tableRowHeight;
	                }
	            }
	        } else {
	            // down键
	            if (selectedRowIndex == len) {
	                selectedRowIndex = perceptionRowIndexWithDown(selectedRowIndex, isMultiSelectedEnabled, len);

	                selectedRowIndex === -1 && focusToTableHeadCheckBox(this.table, this.spaceKeyDown);
	                // 处理焦点行超出视口时的scrollTop
	                this.scrollTop = 0;
	            } else {
	                selectedRowIndex++;
	                // 处理焦点行超出视口时的scrollTop
	                if (tableBody && (selectedRowIndex + 1) * tableRowHeight > tableBody.clientHeight + tableBody.scrollTop) {
	                    this.scrollTop = (selectedRowIndex + 1) * tableRowHeight - tableBody.clientHeight;
	                }
	            }
	        }
	        setTimeout(() => {
	            // 直接设不行，好像bee-table里有对scrollTop的操作，把下面的设值冲掉了
	            tableBody && (tableBody.scrollTop = this.scrollTop);
	        }, 0);
	        this.setState({ selectedRowIndex });
	    }
	};

	// 表格行的className
	rowClassName = (record, index) => {
	    let { selectedRowIndex, selectedValues } = this.state,
	        className = '';
	    if (selectedValues.get(record.refpk)) {
	        className = 'refer-selected-row';
	    }
	    if (selectedRowIndex === index) {
	        className += ' refer-focus-row';
	    }
	    return className.trim();
	};

	// 根据参照类型，获取参照快捷键的顺序
	getHotKeyMap = () => {
	    let { refType } = this.props,
	        { activeKey } = this.state;
	    if (!['tree', 'grid', 'gridTree'].find(e => e === refType)) {
	        refType = 'grid';
	    }
	    return {
	        tree: this.tree,
	        grid: this.grid,
	        gridTree: activeKey == '1' ? this.usual : this.gridTree,
	    }[refType];
	};

	// 根据ele在hotKeyMap中的顺序计算tabindex
	getTabIndex = ele => {
	    let { baseTabIndex } = this.props,
	        hotKeyMap = this.getHotKeyMap(),
	        res = 5 + hotKeyMap.get(ele) * 5 + Number(baseTabIndex);
	    return res;
	};

	// 获取hotKeyMap中的最后一个
	getLastHotKey = () => {
	    let { refType, isShowDisabledData, isHasDisabledData } = this.props,
	        { activeKey } = this.state,
	        hotKeyMap = this.getHotKeyMap(),
	        len = hotKeyMap.size;

	    if (
	        (refType === 'grid' || (refType === 'gridTree' && activeKey == '1')) &&
			!(isShowDisabledData && isHasDisabledData)
	    ) {
	        // 没有显示停用按钮
	        len--;
	    }

	    return [...hotKeyMap.keys()][len - 1];
	};

	// 获取hotKeyMap中的某一个
	getHotKeyByIindex = index => {
	    let { refType, isShowDisabledData, isHasDisabledData } = this.props,
	        { activeKey } = this.state,
	        hotKeyMap = this.getHotKeyMap();

	    if (
	        (refType === 'grid' || (refType === 'gridTree' && activeKey == '1')) &&
			!(isShowDisabledData && isHasDisabledData)
	    ) {
	        // 没有显示停用按钮
	        // len--;
	    }

	    let hi = [...hotKeyMap][index || 0];

	    return hi ? hi[0] : null;
	};

	// 重置快捷键顺序
	resetHotKeyLoop = (ele, e) => {
	    let key = e.keyCode || e.which || e.charCode;
	    if (key === 9 && !e.shiftKey) {
	        if (ele !== this.getLastHotKey()) return;
	        // tab
	        ele === this.getLastHotKey() && this.popWindow && this.popWindow.focus();
	    }
	};

	// tableData highlight
	renderTableLabelHighLight = (title, tableKey, searchKey, flag) => {
	    let searchKeys = this.getSearchConfigCodes();
	    let res = title;
	    if (flag) {
	        res = countTitle(title, searchKey);
	    } else {
	        if (searchKeys.includes(tableKey)) {
	            res = countTitle(title, searchKey);
	        } else {
	            res = title;
	        }
	    }

	    return res;
	};

	// 根据columnConfig获取基本列信息
	getCommonColumns = selectedShow => {
	    const { treeConfig, refType } = this.props;
	    let { columnConfig, searchVal } = this.state,
	        { name: names, code: codes, checked = {}, width = {} } = columnConfig[0];
	    return refType === 'tree'
	        ? treeConfig.name.map((e, i) => {
	            return {
	                title: (
	                    <span className="refer-table-title" fieldid={getSysFieldid(treeConfig.code[i])} title={e}>
	                        {e}
	                    </span>
	                ),
	                key: treeConfig.code[i],
	                width: '150px',
	                render: (text, row) => {
	                    let label =
							row[treeConfig.code[i]] ||
							(row.values &&
								row.values[codes[i]] &&
								(row.values[codes[i]].display || row.values[codes[i]].value || ''));
	                    let highlightLabel =
							label && searchVal && !selectedShow
							    ? this.renderTableLabelHighLight(label, codes[i], searchVal, true)
							    : label;
	                    return (
	                        <div className="refer-td" fieldid={getSysFieldid(treeConfig.code[i])} title={label}>
	                            {highlightLabel || <span>&nbsp;</span>}
	                        </div>
	                    );
	                },
	            };
	        })
	        : names
	            .map((e, i) => {
	                return {
	                    title: (
	                        <span className="refer-table-title" fieldid={getSysFieldid(codes[i])} title={e}>
	                            {e}
	                        </span>
	                    ),
	                    key: codes[i],
	                    width: width[codes[i]] || '150px',
	                    render: (text, row) => {
	                        let label =
								row[codes[i]] ||
								(row.values &&
									row.values[codes[i]] &&
									(row.values[codes[i]].display || row.values[codes[i]].value || ''));
	                        let highlightLabel =
								label && searchVal && !selectedShow
								    ? this.renderTableLabelHighLight(label, codes[i], searchVal, true)
								    : label;
	                        return (
	                            <div className="refer-td" fieldid={getSysFieldid(codes[i])} title={label}>
	                                {highlightLabel || <span>&nbsp;</span>}
	                            </div>
	                        );
	                    },
	                    __type__: 'commonColumn',
	                };
	            })
	            .filter((e, i) => checked[codes[i]] !== false);
	};

	// 检查是否是全选
	isAllChecked = () => {
	    let { selectedValues, tableData } = this.state;
	    let data = tableData[0].rows || [];
	    return !!(selectedValues.size && data.length && data.every(e => selectedValues.has(e.refpk)));
	};

	// 检查是否是仅当前页全选
	isCurrentAllChecked = () => {
	    let { selectedValues, tableData } = this.state;
	    let data = tableData[0].rows || [];
	    return !!(selectedValues.size && selectedValues.size === data.length && data.every(e => selectedValues.has(e.refpk)));
	};

	// 是否是跨页全选
	isRealAllChecked = () => {
	    let resultCache, pkCache, { selectedValues } = this.state;
	    if (pkCache === this.allpks) {
	        return resultCache;
	    }
	    pkCache = this.allpks;
	    resultCache = this.allpks.length > 0 && this.allpks.every(refpk => selectedValues.has(refpk));
	    return resultCache;
	}

	// 检查是否 中间态
	isIndeterminated = () => {
	    let { selectedValues, tableData } = this.state;
	    let data = tableData[0].rows || [];
	    return (
	        selectedValues.size > 0 &&
			data.length &&
			!this.isAllChecked() &&
			data.find(e => selectedValues.has(e.refpk))
	    );
	};

	// 处理树选中的方法
	treeSelect = (node, doubleClickFlag) => {
	    let { selectedValues, treeData } = this.state;
	    const { idKey, isMultiSelectedEnabled, rootNode } = this.props,
	        treeNodeId = node.props.treeNodeData[idKey];
	    if (node.props.treeNodeData[idKey] === rootNode[idKey]) {
	        // 选中根节点：全选
	        if (isMultiSelectedEnabled) {
	            if (this.shouldCheckedRoot === 'all' && !doubleClickFlag) {
	                // 双击时始终全选
	                selectedValues = new Map();
	            } else {
	                selectedValues = new Map(treeData.filter(e => !this.isDisabled(e)).map(e => [e.refpk, e]));
	                // 保证根节点的选中状态
	                selectedValues.set(rootNode.refpk || rootNode[idKey], rootNode);
	            }
	            this.setState({ isMultiSelectMode: true });
	        }
	    } else {
	        // 普通节点
	        if (!node.props.disableCheckbox) {
	            if (isMultiSelectedEnabled) {
	                // 多选
	                selectedValues = this.getSelectTreeValuesThroughIncludeChildren(node, doubleClickFlag);
	            } else if (!isMultiSelectedEnabled) {
	                // 单选
	                selectedValues = new Map(
	                    Object.entries({ [treeNodeId]: node.props.treeNodeData }),
	                );
	            }
	        }
	    }
	    return { selectedValues };
	};

	// 根据条件获取选中的节点
	getSelectTreeValuesThroughIncludeChildren = (node, doubleClickFlag) => {
	    // dbclick: 双击树节点时，始终选中该节点并关闭弹窗
	    let { selectedValues, includeChildren, isMultiSelectMode } = this.state,
	        { idKey } = this.props,
	        treeNodeId = node.props.treeNodeData[idKey],
	        _this = this;
	    if (includeChildren) {
	        // 包含下级
	        let mapFunc = !doubleClickFlag && selectedValues.get(treeNodeId) ? selectedValues.delete : selectedValues.set;
	        // 选中所有下级节点
	        (function func(data) {
	            // 寻找原始的子节点，而不是过滤之后的子节点
	            let children = _this.originGroup[data[idKey]];
	            mapFunc.call(selectedValues, data[idKey], data);
	            if (Array.isArray(children)) {
	                children.forEach(e => func(e));
	            }
	        })(node.props.treeNodeData);
	        // 变为多选模式
	        this.setState({ isMultiSelectMode: true });
	    } else {
	        // 选中单个节点
	        let data = node.props.treeNodeData;
	        if (isMultiSelectMode) {
	            // 多选模式
	            if (doubleClickFlag) {
	                // 双击
	                selectedValues.set(treeNodeId, data);
	            } else {
	                this.toggleValueForMapOrObject(selectedValues, treeNodeId, data);
	            }
	        } else {
	            // 单选模式
	            selectedValues = new Map([[treeNodeId, data]]);
	        }
	    }

	    // 额外进行批选操作
	    let dataForBatch = this.batchSelectTreeNode(node.props.treeNodeData);
	    dataForBatch.forEach(item => {
	        selectedValues.set(item[idKey], item);
	    });

	    return selectedValues;
	};

	// 树的双击事件
	onTreeNodeDoubleClick = (checkedKeys, { node }) => {
	    let { refType, isMultiSelectedEnabled, pageSize, idKey, rootNode } = this.props,
	        pid = node.props.treeNodeData[idKey],
	        { searchVal, isExpandLeftArea, expandedKeys } = this.state;

	    if (refType === 'tree') {// 单选时，根节点不可双击
	        if (node.props.treeNodeData[idKey] !== rootNode[idKey] || isMultiSelectedEnabled) {
	            let { selectedValues } = this.treeSelect(node, true);
	            if (node.props.disableCheckbox && !isMultiSelectedEnabled) {
	                selectedValues = selectedValues = new Map(
	                    Object.entries({ [pid]: node.props.treeNodeData }),
	                );
	            }
	            this.setState(
	                { selectedValues },
	                () => {
	                    if (!node.props.disableCheckbox) {
	                        isMultiSelectedEnabled
	                            ? this.multiSelect()
	                            : this.singleSelect([...selectedValues.values()][0]);
	                        this.handlePopoverBlur();
	                    }
	                },
	            );
	        }
	    } else if (refType === 'gridTree') {
	        if (!isExpandLeftArea || node.props.treeNodeData[idKey] === rootNode[idKey]) {
	            return;
	        }
	        // 树表时，并且左侧树展开时：选中节点，收起展开
	        this.loadAndSetTableData({
	            pid: node.props.treeNodeData.refpk,
	            pageInfo: {
	                pageIndex: 0,
	                pageSize,
	            },
	            keyword: searchVal,
	        });
	        this.setState({
	            isExpandLeftArea: false,
	            expandedKeys: [...new Set([...expandedKeys, pid])],
	        });
	    }
	    this.setState({ selectedKeys: [pid] });
	    // onEnter 逻辑添加 by bbqin
	    // setTimeout(() => {this.props.onEnter && this.props.onEnter({e: event, target: this.referInput});}, 20);
	};

	// 左树的点击事件：左树右表时查右表数据, 树时选中节点
	onTreeNodeSelect = (_selectedKeys, { node }) => {
	    // console.log('点击树：', _selectedKeys, { selected, selectedNodes, node, event });
	    let keyPressFlag = false;
	    if (window.event && ['keyCode', 'charCode', 'which'].find(e => window.event[e])) {
	        keyPressFlag = true;
	    }
	    let { refType, idKey, pageSize, rootNode, isMultiSelectedEnabled, rootNodeSelectable } = this.props,
	        pid = node.props.treeNodeData[idKey],
	        { searchVal, isExpandLeftArea, selectedValues, selectedKeys, expandedKeys, isTreeSearch, isMultiSelectMode, includeChildren } = this.state;

	    // 单击展开并选中
	    !keyPressFlag && (expandedKeys = [...new Set([...expandedKeys, pid])]);
	    selectedKeys = [pid];

	    // 查下级
	    !keyPressFlag && this.loadTreeChildrenDataIfNeeded(node);

	    if (refType === 'gridTree') {
	        // 左树右表
	        let searchPid = node.props.treeNodeData.refpk;
	        if (node.props.treeNodeData[idKey] === rootNode[idKey]) {
	            if (isTreeSearch || rootNodeSelectable) {
	                searchPid = '';
	            } else {
	                return;
	            }
	        }
	        if (!node.props.disableCheckbox) {
	            if (!isExpandLeftArea) {
	                // 查右表数据
	                this.loadAndSetTableData({
	                    pid: searchPid,
	                    pageInfo: {
	                        pageIndex: 0,
	                        pageSize,
	                    },
	                    keyword: searchVal,
	                });
	            }
	        }
	    } else if (refType === 'tree') {
	        // 树 TODO:包含下级待确认
	        if (!((keyPressFlag || isMultiSelectMode) && isMultiSelectedEnabled) && !includeChildren) {
	            // 多选树：快捷键space选中时，onSelect和onCheck都会触发，会导致选择无效，所以做此处理
	            ({ selectedValues } = this.treeSelect(node));
	            if (node.props.disableCheckbox && !isMultiSelectedEnabled) {
	                selectedValues = new Map(
	                    Object.entries({ [pid]: node.props.treeNodeData }),
	                );
	            }
	            this.setState({ selectedValues });
	        }
	    }
	    this.setState({
	        expandedKeys,
	        selectedKeys,
	    });
	};

	// 根据条件获取下级数据
	loadTreeChildrenDataIfNeeded = node => {
	    let { pageSize, idKey, isTreelazyLoad } = this.props,
	        { isTreeSearch } = this.state,
	        treeNodeData = node.props.treeNodeData;
	    if (isTreelazyLoad && !isTreeSearch) {
	        !node.props?.treeNodeData?.isleaf &&
				this.loadAndSetTreeData(
				    {
				        pid: treeNodeData[idKey],
				        pageInfo: {
				            pageSize,
				            pageIndex: -1,
				        },
				    },
				    treeNodeData,
				);
	    }
	};

	// 左树的勾选事件：多选树时
	onTreeNodeCheck = (checkedKeys, { node }) => {
	    // console.log('树选中', checkedKeys, { checked, checkedNodes, node, event });
	    let keyPressFlag = false;
	    if (window.event && ['keyCode', 'charCode', 'which'].find(e => window.event[e])) {
	        keyPressFlag = true;
	    }
	    //如果是批量选择就不去做防抖 批量选择时添加的状态[selectTreeNodeWithBatch]
	    if (keyPressFlag === false || this.selectTreeNodeWithBatch) {
	        this.setState(
	            {
	                isMultiSelectMode: true,
	                selectedKeys: [node.props.treeNodeData[this.props.idKey]],
	            },
	            () => {
	                let { selectedValues } = this.treeSelect(node);
	                this.setState({ selectedValues });
	            },
	        );
	    } else {
	        if (this.timer) {
	            clearTimeout(this.timer);
	            this.timer = null;
	        }
	        this.timer = setTimeout(() => {
	            /**
				 * 长按space键时在按钮keyUp时会再次触发此回调，所以在keyFun中添加标识pressOnTreeNode判断一下
				 */
	            if (this.pressOnTreeNode) {
	                this.pressOnTreeNode = false;
	                return;
	            }
	            this.setState(
	                {
	                    isMultiSelectMode: true,
	                    selectedKeys: [node.props.treeNodeData[this.props.idKey]],
	                },
	                () => {
	                    let { selectedValues } = this.treeSelect(node);
	                    this.setState({ selectedValues });
	                    this.pressOnTreeNode = false;
	                },
	            );
	            clearTimeout(this.timer);
	            this.timer = null;
	        }, 200);
	    }
	};

	// 左树的展开事件
	onTreeNodeExpand = (expandedKeys, { expanded, node }) => {
	    // console.log('节点展开：', expandedKeys, { expanded, node });
	    let { onTreeNodeExpand, isTreelazyLoad, pageSize, idKey } = this.props,
	        { isTreeSearch } = this.state;
	    this.run(onTreeNodeExpand, node);
	    if (expanded && isTreelazyLoad && !isTreeSearch) {
	        this.loadAndSetTreeData(
	            {
	                pid: node.props.treeNodeData[idKey],
	                pageInfo: {
	                    pageSize,
	                    pageIndex: -1,
	                },
	            },
	            node.props.treeNodeData,
	        );
	    }
	    this.setState({ expandedKeys });
	};

	// ctrl/shift快捷键批量选树节点
	batchSelectTreeNode = node => {
	    if (this.shiftKey) {
	        if (this.startIndex === 0) {
	            // 还没选开始节点
	            this.startIndex = node.index;
	            this.endIndex = 0;
	        } else {
	            this.endIndex = node.index;
	        }
	    } else {
	        this.startIndex = node.index;
	        this.endIndex = 0;
	    }
	    if (this.endIndex > 1) {
	        // 1是根节点
	        // 批量选
	        let dataForBatch;
	        if (this.startIndex < this.endIndex) {
	            dataForBatch = this.state.treeData.slice(this.startIndex - 1, this.endIndex);
	        } else {
	            dataForBatch = this.state.treeData.slice(this.endIndex - 1, this.startIndex);
	        }
	        this.startIndex = 0;
	        this.endIndex = 0;
	        this.setState({ isMultiSelectMode: true });
	        return dataForBatch;
	    } else {
	        return [];
	    }
	};

	// 已选择页签中的删除事件
	onSelectedRowClick = row => {
	    let { selectedValues } = this.state;
	    selectedValues.delete(row.refpk);
	    this.setState({ selectedValues });
	};

	// 右侧表格行点击
	onRowClick = (record, index, e) => {
	    // 为了避免和新开发的行框选点选区域选事件冲突
	    if (e.ctrlKey || e.shiftKey || e.metaKey) {
	        return;
	    }
	    e.stopPropagation();
	    let { isMultiSelectedEnabled } = this.props,
	        { selectedValues, isMultiSelectMode } = this.state;
	    if (isMultiSelectedEnabled) {
	        // 多选
	        if (!isMultiSelectMode) {
	            // 单选模式
	            selectedValues = new Map([[record.refpk, record]]);
	        }
	    } else {
	        // 单选
	        selectedValues = new Map(
	            Object.entries({ [record.refpk]: record }),
	        );
	    }
	    this.setState({
	        selectedValues,
	        selectedRowIndex: index,
	    });
	};

	// 表格行双击
	onRowDoubleClick = (record, index, e) => {
	    e.stopPropagation();
	    let { isMultiSelectedEnabled } = this.props,
	        { selectedValues, isMultiSelectMode } = this.state;
	    if (isMultiSelectedEnabled && isMultiSelectMode) {
	        // 多选
	        selectedValues.set(record.refpk, record);
	        this.multiSelect();
	    } else {
	        // 单选
	        // selectedValues = new Map(
	        // 	Object.entries({
	        // 		[record.refpk]: record
	        // 	})
	        // );
	        selectedValues.clear();
	        this.singleSelect(record);
	    }
	    this.handlePopoverBlur();
	};

	// 获取并设置表格值
	loadAndSetTableData = (_param, useCache = true, showing, lazyRefresh) => {
	    let param = this.__getParam(_param);
	    this.loadTableData(param, useCache).then(data => {
	        this.setTableData('tableData', 0, data);
	        !lazyRefresh && this.focusAreaOnPopup(showing);
	    });
	};

	// 获取并且设置树的数据
	loadAndSetTreeData = (_param, rootNode) => {
	    let param = this.__getParam(_param);
	    this.loadTreeData(param).then(data => {
	        this.setTreeData('treeData', rootNode, data);
	    });
	};

	// 弹出框中的搜索表事件
	popSearchTable = keyword => {
	    // grid和gridTree走这个方法
	    let { selectedKeys, tableData, activeKey } = this.state,
	        { rootNode, refType, idKey, selectRootNodeWhenGridTreeReferSearch } = this.props;
	    if (keyword || refType === 'grid' || activeKey == '1') {
	        // 左树右表时：取消树节点的选中状态
	        selectRootNodeWhenGridTreeReferSearch && refType === 'gridTree' && (selectedKeys = [rootNode[idKey]]);
	        tableData[0].page.pageIndex = 0;
	        this.loadAndSetTableData({
	            pageInfo: tableData[0].page,
	            keyword,
	        });
	    } else {
	        tableData = [
	            {
	                rows: [],
	                page: {
	                    pageIndex: 1,
	                    totalPage: 1,
	                },
	            },
	        ];
	        this.setState({ tableData });
	    }
	    this.setState(
	        {
	            isSearch: !!keyword,
	            selectedKeys,
	        },
	        () => {
	            refType === 'gridTree' && this.refTree && dealTreeFocusItem(this.refTree);
	        },
	    );
	};

	// 弹出框中树的搜索事件
	popSearchTree = keyword => {
	    // tree走这个方法
	    let { expandedKeys, isTreeSearch } = this.state;
	    const { rootNode, isTreelazyLoad } = this.props;
	    isTreeSearch = !!keyword;
	    if (keyword) {
	        this._expandedKeys = this._expandedKeys || JSON.parse(JSON.stringify(expandedKeys));
	    }

	    let param = this.__getParam({
	        keyword: isTreelazyLoad ? keyword : '',
	        pageInfo: { pageIndex: -1 },
	    });

	    this.loadTreeData(param).then(data => {
	        !isTreelazyLoad && (data.rows = this.treeFilter(data.rows, keyword));
	        this.setTreeData('treeData', rootNode, data);
	    });

	    this.setState({ isTreeSearch });
	};

	// 取消按钮事件
	cancel = () => {
	    const { isMultiSelectedEnabled } = this.props;

	    let resizeContainer = this.dragContainer.querySelector('.js-resize-container');
	    let height = calculateResizeContainerHeight(this.dragContainer, 'close') + 'px';
	    setContainerStyle({
	        container: resizeContainer,
	        width: resizeContainer.style.minWidth,
	        minHeight: height,
	        transform: 'translate(0px, 0px)',
	        height,
	    });
	    resizeContainer = null;

	    this.setState(() => {
	        let resizePosition = {
	            x: 0,
	            y: 0,
	        };
	        let params = isMultiSelectedEnabled
	            ? {
	                selectedValues: new Map(JSON.parse(JSON.stringify(this._value))),
	                // referVal: '',
	                isMoreButtonShow: false,
	                referContentAreaHeight: REFER_CONTENT_AREA_HEIGHT,
	            }
	            : {
	                selectedValues: new Map(JSON.parse(JSON.stringify(this._value))),
	                isMoreButtonShow: false,
	                referContentAreaHeight: REFER_CONTENT_AREA_HEIGHT,
	            };
	        return { ...params, resizePosition };
	    });
	    this.handlePopoverBlur();
	};

	// 存入列设置
	pushToColumnConfig = () => {
	    // [{name: ['编码', '名称'], code: ['refcode', 'refname']}]
	    let { queryGridUrl, queryTreeUrl } = this.props,
	        { columnConfig: config } = this.state,
	        configKey = queryGridUrl + queryTreeUrl,
	        ColumnConfig = JSON.parse(getGlobalStorage('localStorage', 'ColumnConfig') || '{}');

	    ColumnConfig[configKey] = config;
	    this.setStorage('ColumnConfig', JSON.stringify(ColumnConfig));
	};

	// 从localStorage中取列设置
	getColumnConfig = props => {
	    let { columnConfig, queryGridUrl, queryTreeUrl } = props || this.props,
	        configKey = queryGridUrl + queryTreeUrl;
	    return (
	        JSON.parse(getGlobalStorage('localStorage', 'ColumnConfig') || '{}')[configKey] ||
			JSON.parse(JSON.stringify(columnConfig))
	    );
	};

	// 重置列设置
	resetColumnConfig = () => {
	    let { queryGridUrl, queryTreeUrl } = this.props,
	        configKey = queryGridUrl + queryTreeUrl,
	        ColumnConfig = JSON.parse(getGlobalStorage('localStorage', 'ColumnConfig') || '{}');
	    delete ColumnConfig[configKey];
	    this.setStorage('ColumnConfig', JSON.stringify(ColumnConfig));
	    this.setState({ columnConfig: this.getColumnConfig() });
	};

	pushToReferTreeConfig = width => {
	    let { queryGridUrl, queryTreeUrl } = this.props,
	        configKey = queryGridUrl + queryTreeUrl,
	        referTreeConfig = JSON.parse(getGlobalStorage('localStorage', 'referTreeConfig') || '{}');

	    referTreeConfig[configKey] = width;
	    this.setStorage('referTreeConfig', JSON.stringify(referTreeConfig));
	}

	// 从localStorage中取列设置
	getReferTreeConfig = () => {
	    let { queryGridUrl, queryTreeUrl, treeWidth } = this.props,
	        configKey = queryGridUrl + queryTreeUrl;
	    return (
	        JSON.parse(getGlobalStorage('localStorage', 'referTreeConfig') || '{}')[configKey] ||
			treeWidth
	    );
	};

	// 表格部分的全选
	checkAll = val => {
	    let { tableData, selectedValues } = this.state;
	    let data = tableData[0].rows || [];
	    if (val) {
	        data.forEach(e => {
	            selectedValues.set(e.refpk, e);
	        });
	    } else {
	        data.forEach(e => {
	            selectedValues.delete(e.refpk);
	        });
	    }
	    this.setState({ selectedValues });
	};

	// 复写原型方法：设置表格数据
	setTableData = (target, level, data) => {
	    this.setState({ loading: false });
	    let targetData = this.state[target];
	    // 防止出现展开箭头
	    data.rows.forEach(row => {
	        delete row.children;
	        delete row.isleaf;
	    })
	    targetData[level] = {
	        page: data.page,
	        rows: data.rows,
	    };
	    if (data.page && data.page.pageIndex == 0) {
	        this.allpks = data.page.allpks || [];
	        this.totalPage = data.page.totalPage;
	    }
	    targetData[level].page && (targetData[level].page.totalPage = this.totalPage || 0);
	    this.setState({ [target]: targetData }, () => {
	        this.refreshTip();
	    });
	};

	loadUsualData = (loading = true) => {
	    let { pageSize, queryGridUrl } = this.props,
	        param = this.__getParam({
	            pageInfo: {
	                pageIndex: -1,
	                pageSize,
	            },
	        });
	    param.queryCondition.isShowUsual = true;
	    param.queryCondition.UsualActionURL = queryGridUrl;
	    return this.loadTableData(param, false, loading);
	};

	// 检查是否存在常用数据
	checkUsual = callback => {
	    const { isShowUsual, refType, queryCommonUseWhenOpen } = this.props;
	    if (queryCommonUseWhenOpen && isShowUsual && refType === 'gridTree') {
	        // 先查左树数据，作为filterPids
	        this.loadUsualData().then(data => {
	            if (data.rows.length) {
	                // 有常用
	                this.setTableData('tableData', 0, data);
	                this.setState({ activeKey: '1' });
	            } else {
	                this.setState(
	                    { activeKey: '2' },
	                    () => {
	                        this.run(callback);
	                    },
	                );
	            }
	        });
	    } else {
	        this.run(callback);
	    }
	};

	// 焦点选中某个节点 bbqin
	focusAreaOnPopup(showing) {
	    if (showing) {
	        let { baseTabIndex } = this.props,
	            firstIndex = 5 + 1 * 5 + Number(baseTabIndex);

	        let timer = setTimeout(() => {
	            if (firstIndex && this.popWindow) {
	                let first = this.popWindow.querySelector(`[tabindex="${firstIndex}"]`);
	                // console.log(this.popWindow, first, firstIndex);
	                // 让树获取焦点即可，详见onTreeFocus方法
	                // if (first && first.className.indexOf('nc-tree') != -1) {
	                // 	first = first.querySelector(`[tabindex="${firstIndex}"]`);
	                // }
	                first && first.blur();
	                first && first.focus();
	                first = null;
	            }
	            clearTimeout(timer);
	        }, 20);
	    }
	}

	checkAddButtons = () => {
	    let { addButtonList } = this.state;
	    let { addButtons, hasAddButton } = this.props;
	    if (hasAddButton && !addButtonList && Array.isArray(addButtons)) {
	        let buttonsMap = {};
	        ajax({
	            url: '/nccloud/platform/pub/refadd.do',
	            data: {
	                appcodes: addButtons.map(button => {
	                    let { appcode } = button;
	                    buttonsMap[appcode] = button;
	                    return appcode;
	                }),
	            },
	            loading: false,
	            success: res => {
	                if (res.success) {
	                    this.setState({
	                        addButtonList: res.data.AppRegisterVOs.map(({ code, name }) => {
	                            buttonsMap[code].name = buttonsMap[code].name || name;
	                            return buttonsMap[code];
	                        }),
	                    })
	                }
	            },
	        })
	    }
	}

	loadAndSetTableDataAgainIfEmpty = (_param, useCache = true, showing, lazyRefresh) => {
	    let param = this.__getParam(_param);
	    this.loadTableData(param, useCache).then(data => {
	        if (!data.length && param.pageInfo.pageIndex > 0) {
	            param.pageInfo.pageIndex = 0;
	            this.loadAndSetTableData(param, useCache, showing)
	        } else {
	            this.setTableData('tableData', 0, data);
	            !lazyRefresh && this.focusAreaOnPopup(showing);
	        }
	    });
	};

	// 复写原型方法：点击参照三个点的事件
	show = (lazyRefresh = false) => {
	    this.focusFlag = false;

	    let { disabled, isTreelazyLoad, idKey, searchWithKeywordOutsideWhenOpen, clearUnitValueWhenOpen, expandAllNodeWhenFirstOpen } = this.props,
	        {
	            selectedValues,
	            selectedKeys,
	            includeChildren,
	            activeKey,
	            isExpandLeftArea,
	            searchVal,
	            referVal,
	            expandedKeys,
	            multiSearch,
	            isFirstShow,
	        } = this.state,
	        { isSearchStatus } = this.getStatus(),
	        needSearch = searchWithKeywordOutsideWhenOpen && isSearchStatus && !multiSearch;

	    if (disabled) {
	        return false;
	    }

	    if (!lazyRefresh && clearUnitValueWhenOpen) {
	        this.state.unit = {};
	    }

	    let { refType, rootNode, pageSize, isMultiSelectedEnabled } = this.props,
	        { tableData } = this.state,
	        param;

	    this.checkAddButtons();

	    // 先查常用，常用没有的话再查全部
	    (cb => {
	        if (needSearch) {
	            //把搜索结果带到界面
	            cb();
	        } else {
	            // lazyRefresh：只刷新当前页面
	            // lazyRefresh可能是e
	            if (lazyRefresh) {
	                activeKey === '2'
	                    ? cb()
	                    : this.loadAndSetTableData(
	                        {
	                            pageInfo: {
	                                pageIndex: -1,
	                                pageSize,
	                            },
	                        },
	                        false,
	                        true,
	                        lazyRefresh,
	                    );
	            } else {
	                this.checkUsual(cb);
	            }
	        }
	    })(() => {
	        // 没常用，查全部
	        if (refType === 'grid') {
	            searchVal && (tableData[0].page.pageIndex = 0);
	            param = this.__getParam({
	                pageInfo: tableData[0].page,
	                keyword: needSearch ? referVal : '',
	            });
	            this.loadAndSetTableDataAgainIfEmpty(param, true, true, lazyRefresh);
	        } else {
	            param = this.__getParam({
	                pid: isTreelazyLoad ? rootNode.refpk : '',
	                pageInfo: {
	                    pageSize,
	                    pageIndex: -1,
	                },
	                keyword: '',
	            });
	            this.loadTreeData(param).then(data => {
	                this.setTreeData('treeData', rootNode, data, () => {
	                    if (isFirstShow && expandAllNodeWhenFirstOpen) {
	                        this.setState({ expandedKeys: [rootNode[idKey]].concat(data.rows.map(e => e[idKey])) });
	                    }
	                    !lazyRefresh && this.focusAreaOnPopup(true);
	                });
	                if (refType === 'gridTree') {
	                    if (needSearch) {
	                        param = this.__getParam({ keyword: referVal });
	                        this.loadAndSetTableDataAgainIfEmpty(param, true, true, lazyRefresh);
	                    } else {
	                        let { treeDataWithChildren, keyMap } = this.state,
	                            { selectFirstTreeNodeWhenOpen } = this.props,
	                            firstSelectedKeys = selectedKeys[0];
	                        if (keyMap[firstSelectedKeys]) {
	                            // 选中的节点是真实存在的
	                            firstSelectedKeys = keyMap[firstSelectedKeys].refpk;
	                        } else {
	                            firstSelectedKeys = '';
	                        }
	                        try {
	                            // 默认第一个节点
	                            let firstTreeNode = treeDataWithChildren[0].children[0];
	                            !firstSelectedKeys && (firstSelectedKeys = firstTreeNode.refpk || firstTreeNode[idKey]);
	                        } catch (e) { }
	                        if (selectFirstTreeNodeWhenOpen && firstSelectedKeys) {
	                            // 查右表
	                            param = this.__getParam({ pid: firstSelectedKeys });
	                            this.loadAndSetTableDataAgainIfEmpty(param, true, true, lazyRefresh);
	                            this.setState(
	                                { selectedKeys: [firstSelectedKeys] },
	                                () => {
	                                    !lazyRefresh && this.focusAreaOnPopup(true);
	                                },
	                            );
	                        } else {
	                            // 重置左树和右表
	                            selectedKeys = [];
	                            tableData[0].rows = [];
	                            this.setState(
	                                {
	                                    tableData,
	                                    selectedKeys,
	                                },
	                                () => {
	                                    !lazyRefresh && this.focusAreaOnPopup(true);
	                                },
	                            );
	                        }
	                    }
	                }
	            });
	        }
	        this.setState(
	            { activeKey: '2' },
	            () => {
	                !lazyRefresh && this.focusAreaOnPopup(true);
	            },
	        );
	    });
	    if (refType === 'tree') {
	        if (isMultiSelectedEnabled) {
	            // 多选时选中第一个节点
	            let trueValue = this.getTrueValue(),
	                firstSelectedNode = trueValue && trueValue[0],
	                { idKey } = this.props;
	            if (firstSelectedNode) {
	                let firstSelectedKey = firstSelectedNode.refpk || firstSelectedNode[idKey];
	                selectedKeys = [firstSelectedKey];
	            } else {
	                selectedKeys = [];
	            }
	        } else {
	            selectedKeys = [...this._value.values()].slice(0, 1).map(e => e[idKey]);
	        }
	    }
	    this.runWithChildren = !!this.state.runWithChildren;
	    
	    this.setState(
	        {
	            isShow: true,
	            isFirstShow: false,
	            dropDownShow: false,
	            isSelectedShow: false,
	            searchVal: needSearch && refType !== 'tree' ? referVal : '',
	            treeSearchVal: needSearch && refType === 'tree' ? referVal : '',
	            selectedShow: false,
	            isAddButtonShow: false,
	            currentButtonIndex: 0,
	            // max: lazyRefresh === true ? max : false,
	            isExpandLeftArea: lazyRefresh ? isExpandLeftArea : false,
	            selectedKeys,
	            isMultiSelectMode:
					isMultiSelectedEnabled && !([...selectedValues.keys()].length <= 1 && !includeChildren),
	            selectedRowIndex: -1,
	            dragStartPosition: { x: 0, y: 0 },
	            isTreeSearch: needSearch && refType === 'tree',
	            isSearch: needSearch && refType !== 'tree',
	            expandedKeys: isTreelazyLoad ? [rootNode[idKey]] : expandedKeys,
	            unit: this.state.unit,
	        },
	        () => {
	            this.referInput && this.referInput.blur();
	            // 防止焦点丢失
	            // !this.unitReferFocusFlag &&
	            this.popWindow && !this.popWindow.contains(document.activeElement) && this.popWindow.focus();
	            !lazyRefresh && this.focusAreaOnPopup(true);

	            //刷新时不去计算高度
	            !lazyRefresh && calculateResizeContainerHeight(this.dragContainer);
	            if (needSearch) {
	                refType === 'tree' ? this.popSearchTree(referVal) : this.popSearchTable(referVal);
	            }
	            this.max(this.state.max);
	        },
	    );
	};

	// 树获取焦点的事件
	onTreeFocus = existFlag => {
	    let { scrollSelectedNodeIntoView } = this.props;
	    if (!existFlag && scrollSelectedNodeIntoView) {
	        return new Promise(resolve => {
	            let { pidKey, idKey, rootNode } = this.props,
	                { selectedKeys, expandedKeys, keyMap } = this.state,
	                targetKey = (selectedKeys || [])[0],
	                parents = [],
	                pid;
	            if (targetKey) {
	                while (keyMap[targetKey]) {
	                    pid = keyMap[targetKey][pidKey];
	                    pid = keyMap[pid] ? pid : rootNode[idKey];
	                    pid && parents.push(pid);
	                    if (pid === rootNode[idKey]) {
	                        targetKey = '';
	                    } else {
	                        targetKey = keyMap[pid] ? keyMap[pid][idKey] : '';
	                    }
	                }
	                this.setState(
	                    { expandedKeys: [...new Set([...expandedKeys, ...parents])] },
	                    () => {
	                        try {
	                            // 定位到选中节点
	                            setTimeout(() => {
	                                document.activeElement.scrollIntoView();
	                            }, 150);
	                        } catch (e) { }
	                        resolve(true);
	                    },
	                );
	            }
	        });
	    }
	};

	// 界面最大化
	max = max => {
	    // 目的是不动下面的原有逻辑，且使max不变
	    if (max !== undefined) {
	        this.state.max = !max;
	    }
	    /*
		* 如果窗口状态为最小化重新赋值内容高度，
		* 窗口改变时都初始化拖动位置，防止拖动位置计算出错
		*/
	    this.setState({
	        max: !this.state.max,
	        referContentAreaHeight:
				!this.state.max === false ? REFER_CONTENT_AREA_HEIGHT : this.state.referContentAreaHeight,
	        dragStartPosition: {
	            x: 0,
	            y: 0,
	        },
	    });

	    //页面最大化/最小化时计算容器的宽高
	    let resizeContainer = this.dragContainer && this.dragContainer.querySelector('.js-resize-container');
	    let dragWrapped = this.dragContainer && this.dragContainer.querySelector('.js-drag-wrapped');

	    setContainerStyle({
	        container: dragWrapped,
	        transform: 'translate(0px, 0px)',
	    });

	    if (!this.state.max === true) {
	        setContainerStyle({
	            container: dragWrapped,
	            width: '100%',
	            height: '100%',
	        });

	        setContainerStyle({
	            container: resizeContainer,
	            width: '100%',
	            height: '100%',
	            transform: 'translate(0px, 0px)',
	        });
	    } else {
	        let minWidth = resizeContainer?.style?.minWidth;
	        setContainerStyle({
	            container: dragWrapped,
	            width: minWidth,
	            height: CONTAINER_DEFAULT_MIN_HEIGHT + 'px',
	        });
	        setContainerStyle({
	            container: resizeContainer,
	            width: minWidth,
	            height: CONTAINER_DEFAULT_MIN_HEIGHT + 'px',
	        });
	    }
	};

	// 树表：展开左侧树
	toggleExpandLeftArea = () => {
	    this.setState({ isExpandLeftArea: !this.state.isExpandLeftArea });
	};

	// shift + tab 切換面板内元素 目前树中没有事件所以树不能触发 bbqin TODO 等树更新onKeydown回调
	popWindowKeyDownHandle = e => {
	    // console.log(e.keyCode, e.shiftKey, document.activeElement);
	    e.stopPropagation();
	    let tabIndex = document.activeElement.tabIndex;
	    if (tabIndex > 0 && e.keyCode === 9) {
	        let hotKeyList = [...this.getHotKeyMap()];
	        let maxLen = hotKeyList.length - 1;
	        let baseTabIndex = Number(this.props.baseTabIndex);
	        let currentIndex = (tabIndex - baseTabIndex - 5) / 5;

	        if (currentIndex === 1 && e.shiftKey) {
	            // shift + tab
	            e.preventDefault();
	            // 判斷是否 臨界點
	            currentIndex = maxLen;
	            let nextIndex = 5 + maxLen * 5 + Number(this.props.baseTabIndex);
	            let nextElem = this.popWindow.querySelector(`[tabindex="${nextIndex}"]`);
	            // console.log(currentIndex, nextElem, nextIndex, `[tabindex="${nextIndex}"]`, this.popWindow);
	            while (nextElem === null) {
	                maxLen = maxLen - 1;
	                nextIndex = 5 + maxLen * 5 + Number(this.props.baseTabIndex);
	                nextElem = this.popWindow.querySelector(`[tabindex="${nextIndex}"]`);
	            }
	            nextElem && nextElem.focus();

	            nextElem = null;
	        }
	    }
	};

	// 复写原型方法：渲染弹出层
	renderPopover = () => {
	    const {
	        container,
	        popWindowClassName,
	        isMultiSelectedEnabled,
	        refType,
	        isShowUsual,
	        attrcode,
	        fieldid,
	        useLoading,
	    } = this.props;
	    let { isFirstShow, isShow, max, activeKey, isExpandLeftArea, dragStartPosition, selectedShow, loading } = this.state;
	    let bottom = this.renderPopoverBottom();
	    let fieldidValue = null;
	    let minWidth = calculateMinWidth({ refType, max, activeKey, isExpandLeftArea });
	    if (fieldid || attrcode) {
	        fieldidValue = `${fieldid || attrcode}_refer-window`;
	    }
	    fieldidValue = getSysFieldid(fieldidValue);

	    //有两个弹窗时拖动一个另一个也会跟着移动，因此每个弹窗都生成唯一的类名
	    let uniqueBoundsClass = getUniqueClass();

	    let height = isShow ? ((this.popover || {}).clientHeight || 0) - 85 : 0; // header + footer = 85

	    let emptyText = this.haveNoData ? {} : { emptyText: () => '' };

	    let selectColumns = [];
	    const { rowKey, columnConfig } = this.props,
	        { sort } = columnConfig[0];
	    selectColumns.push({
	        // 操作
	        title: <span fieldid={getSysFieldid('opr')}> {this.state.jsonInsideRefer['containers-refer-0025']} </span>,
	        key: 'operate',
	        width: 100,
	        fixed: 'right',
	        render: (text, row, index) => {
	            return (
	                <span
	                    fieldid={getSysFieldid('opr')}
	                    className="refer-del"
	                    onClick={this.onSelectedRowClick.bind(null, row, index)}
	                >
	                    {/* 移除 */}
	                    {this.state.jsonInsideRefer['containers-refer-0026']}
	                </span>
	            );
	        },
	    });
		
	    selectColumns.unshift(...this.getCommonColumns(selectedShow));

	    return ReactDOM.createPortal(
	        // eslint-disable-next-line
	        <div
	            fieldid={fieldidValue}
	            className={`refer-pop-window ${popWindowClassName} drag-area ${isShow ? 'disabled-bg-btn refer-pop-window-show' : 'refer-pop-window-hide'} reftype-${refType} ${max ? 'refer-max' : ''}`}
	            style={{
	                display: isShow ? 'flex' : 'none',
	                padding: max ? `${PADDING_TOP_IN_MAX_STATUS}px ${PADDING_LEFT_IN_MAX_STATUS}px` : '0',
	            }}
	            // 這裏原來用來解決 表格内編輯導致 多次渲染的問題
	            // 但是在firefox 61.0.2 版本導致 面板内input不显示光标
	            onMouseOver={e => {
	                e.stopPropagation();
	            }}
	            onDoubleClick={e => {
	                e.stopPropagation();
	            }}
	            // 阻止传送门 事件
	            onFocus={e => {
	                e.stopPropagation();
	            }}
	            ref={dom => {
	                this.popWindow = dom;
	            }}
	            tabIndex={this.getTabIndex(this.hotKeyElement.referPopWindow)}
	            onKeyDown={this.popWindowKeyDownHandle}
	        >
	            {isFirstShow || (
	                <Dnd
	                    handle={`.drag-modal-${uniqueBoundsClass}`}
	                    cancel=".cancel-drag"
	                    ref={dom => {
	                        this.dragContainer = ReactDOM.findDOMNode(dom);
	                    }}
	                    defaultClassName="js-drag-wrapped"
	                    position={dragStartPosition}
	                    onStart={this.onDragStart}
	                    onStop={this.onDragStop}
	                >
	                    <div
	                        style={{
	                            width: max
	                                ? '100%'
	                                : minWidth,
	                        }}
	                    >
	                        <Resizable
	                            // bounds="window"
	                            onResize={this.onResize}
	                            onResizeStop={this.onResizeStop}
	                            onResizeStart={this.onResizeStart}
	                            minWidth={minWidth}
	                            defaultSize={{ width: minWidth }}
	                            className="js-resize-container popover-shadow"
	                            enable={{
	                                top: true,
	                                right: true,
	                                bottom: true,
	                                left: true,
	                                topRight: false,
	                                bottomRight: true,
	                                bottomLeft: false,
	                                topLeft: false,
	                            }}
	                        >
	                            <div
	                                className={`refer-popover clearfix ${max ? 'max' : ''}`}
	                                ref={dom => {
	                                    this.popover = dom;
	                                }}
	                                onClick={e => {
	                                    e.stopPropagation();
	                                }}
	                                onDoubleClick={e => {
	                                    e.stopPropagation();
	                                }}
	                            >
	                                <div
	                                    className={`refer-header drag-modal-${uniqueBoundsClass}`}
	                                    fieldid={getSysFieldid('header-area')}
	                                >
	                                    {isFirstShow || this.renderPopoverHeader()}
	                                </div>

	                                <div
	                                    className="loading-container"
	                                    ref={dom => {
	                                        this.loadingContainer = dom;
	                                    }}
	                                >
	                                    <Loading container={this.loadingContainer} show={useLoading && loading} />
	                                    {isFirstShow || this.renderPopoverContain()}
	                                    {bottom && (
	                                        <div
	                                            className="refer-bottom refer-resize-icon"
	                                            fieldid={getSysFieldid('bottom-area')}
	                                        >
	                                            {isFirstShow || bottom}
	                                        </div>
	                                    )}
	                                </div>
	                                <Collapse in={selectedShow} className="refer-collapse">
	                                    <div>
	                                        <div className="refer-collapse-header">
	                                            <div className="refer-title" key="1" fieldid={getSysFieldid('catSelected_btn')}>
	                                                {/* 查看已选 */}
	                                                {this.state.jsonInsideRefer['containers-refer-0028']}
	                                            </div>
	                                            <div className="refer-close" key="3">
	                                                <span
	                                                    fieldid={getSysFieldid('clear_btn')}
	                                                    onClick={() => {
	                                                        this.setState({ selectedValues: new Map() });
	                                                    }}
	                                                >
	                                                    {/* 清空 */}
	                                                    {this.state.jsonInsideRefer['containers-refer-0029']}
	                                                </span>
	                                                <span
	                                                    style={{ color: '#555' }}
	                                                    fieldid={getSysFieldid('close_btn')}
	                                                    onClick={() => {
	                                                        this.setState({ selectedShow: false });
	                                                    }}
	                                                >
	                                                    {/* 收起 */}
	                                                    {this.state.jsonInsideRefer['containers-refer-0030']}
	                                                </span>
	                                            </div>
	                                        </div>
	                                        <div
	                                            className="refer-table"
	                                            fieldid={getSysFieldid('selected_table')}
	                                            style={{ height, padding: '15px 20px 0', boxSizing: 'border-box' }}
	                                        >
	                                            <Table
	                                                // lazyload={false}
	                                                height={tableRowHeight}
	                                                headerHeight={tableRowHeight}
	                                                rowKey={record => this.getDisplayOrValue(record, rowKey)}
	                                                scroll={{ x: true, y: height - 50 }} // 表头 + padding-top = 50
	                                                columns={selectColumns}
	                                                data={this.getSelections({ cleanIsLeaf: true })}
	                                                addBlankCol={false}
	                                                bodyStyle={{ height: height - 50 }}
	                                                customSort={sort}
	                                                {...emptyText}
	                                            />
	                                        </div>
	                                    </div>
	                                </Collapse>
	                            </div>
	                        </Resizable>
	                    </div>
	                </Dnd>
	            )}
	            {isFirstShow || (
	                <HotKeys
	                    keyMap={{
	                        add: 'ctrl+/',
	                        ok: 'alt+y',
	                        cancel: {
	                            sequence: ['alt+n', 'esc'],
	                            action: 'keyup',
	                        },
	                        tab: 'tab',
	                        space: {
	                            sequence: 'space',
	                            action: 'keydown',
	                        },
	                        enter: 'enter',
	                        up: 'up',
	                        down: 'down',
	                        toUsual: 'shift+left',
	                        toAll: 'shift+right',
	                        pageLeft: 'ctrl+left',
	                        pageRight: 'ctrl+right',
	                        batchSelectTableRow: ['space+up', 'space+down'],
	                        spaceKeyUp: {
	                            sequence: 'space',
	                            action: 'keyup',
	                        },
	                        batchSelectTreeNode: {
	                            action: 'keyup',
	                            sequence: ['space+up', 'space+down'],
	                        },
	                        test: {
	                            sequence: 'space',
	                            action: 'keypress',
	                        },
	                    }}
	                    handlers={{
	                        add: () => {
	                            if (this.getStatus().isShowStatus) {
	                                let { addButtonList } = this.state;

	                                if (Array.isArray(addButtonList)) {
	                                    if (addButtonList.length === 1) {
	                                        // 直接新增
	                                        let { appcode, pagecode } = addButtonList[0];
	                                        pageTo.openTo(null, {
	                                            appcode,
	                                            pagecode,
	                                            status: 'browse',
	                                        })
	                                    } else if (addButtonList.length > 1) {
	                                        // 展开下拉
	                                        this.setState(({ isAddButtonShow }) => {
	                                            isAddButtonShow = !isAddButtonShow;
	                                            if (isAddButtonShow) {
	                                                this.preActiveElement = document.activeElement;
	                                                document.activeElement && document.activeElement.blur();
	                                            } else {
	                                                this.preActiveElement && this.preActiveElement.focus();
	                                                this.preActiveElement = null;
	                                            }
	                                            return { isAddButtonShow };
	                                        })
	                                    }
	                                }
	                            }
	                        },
	                        ok: event => {
	                            if (this.getStatus().isShowStatus) {
	                                event.preventDefault();
	                                (isMultiSelectedEnabled
	                                    ? this.multiSelect
	                                    : this.singleSelect.bind(this, this.getSelections()[0]))(event);
	                                this.handlePopoverBlur();
	                                this.onHotKeyClose();
	                            }
	                        },
	                        cancel: event => {
	                            if (this.getStatus().isShowStatus) {
	                                event.preventDefault();
	                                event.stopPropagation();
	                                this.cancel(event);
	                                this.onHotKeyClose();
	                            }
	                        },
	                        tab: () => {
	                            if (this.getStatus().isShowStatus) {
	                                if (this.state.isMoreButtonShow) {
	                                    this.setState(
	                                        { isMoreButtonShow: false },
	                                        () => {
	                                            this.popWindow && this.popWindow.focus();
	                                        },
	                                    );
	                                }
	                                setTimeout(() => {
	                                    this.setState({ selectedRowIndex: document.activeElement === this.table ? 0 : -1 });
	                                }, 0);
	                            }
	                        },
	                        space: () => {
	                            //如果一直按着space不执行选中效果
	                            if (this.spaceKeyPress) return;

	                            let isShowStatus = this.getStatus().isShowStatus;
	                            this.spaceKeyDown = true;
	                            this.spaceKeyUp = false;

	                            if (isShowStatus && document.activeElement.contains(this.table)) {
	                                let { selectedValues, selectedRowIndex, tableData } = this.state,
	                                    row = tableData[0].rows[selectedRowIndex];
	                                if (isMultiSelectedEnabled) {
	                                    this.toggleValueForMapOrObject(selectedValues, row.refpk, row);
	                                } else {
	                                    selectedValues = new Map([[row.refpk, row]]);
	                                }
	                                this.setState({
	                                    isMultiSelectMode: true,
	                                    selectedValues,
	                                });
	                            }
	                            if (isShowStatus && this.refTree && this.refTree.contains(document.activeElement)) {
	                                let key,
	                                    { selectedKeys, expandedKeys, treeData } = this.state,
	                                    { idKey } = this.props;
	                                if (Array.isArray(selectedKeys) && (key = selectedKeys[0])) {
	                                    let node = treeData.find(e => e[idKey] === key);
	                                    // 单击展开并选中
	                                    expandedKeys = [...new Set([...expandedKeys.concat([key])])];
	                                    // 查下级
	                                    node &&
											this.loadTreeChildrenDataIfNeeded({ props: { treeNodeData: node } });
	                                    this.setState({ expandedKeys });
	                                }
	                            }
	                        },
	                        enter: event => {
	                            let { isAddButtonShow, currentButtonIndex, addButtonList } = this.state;
	                            if (isAddButtonShow) {
	                                let { appcode, pagecode } = addButtonList[currentButtonIndex];
	                                pageTo.openTo(null, {
	                                    appcode,
	                                    pagecode,
	                                    status: 'browse',
	                                })
	                                this.setState({ isAddButtonShow: false })
	                            } else if (this.getStatus().isShowStatus) {
	                                if (this.moreButtonMenu && this.moreButtonMenu.contains(document.activeElement)) {
	                                    return;
	                                }

	                                //由于延时componentWillUnmount先执行,导致this.referInput是 null，因此先保存一下单元格
	                                let td =
										this.props.renderInTable && this.referInput && findParentTd(this.referInput);

	                                event.preventDefault();
	                                let { refType } = this.props,
	                                    { selectedRowIndex, tableData } = this.state,
	                                    record = tableData[0].rows[selectedRowIndex];
	                                if (
	                                    refType === 'tree' &&
										this.refTree &&
										this.refTree.contains(document.activeElement)
	                                ) {
	                                    // this.onTreeNodeDoubleClick
	                                    this.onHotKeyClose(); // 这个方法里有个聚焦操作 根据判断条件才调用 避免焦点丢失
	                                } else if (
	                                    refType !== 'tree' &&
										this.table &&
										this.table.contains(document.activeElement)
	                                ) {
	                                    // 默认情况下 焦点在表头  record 可能是没有值的 然后就会报错
	                                    !record && console.log('焦点在表头或者没有获取到选中记录！');
	                                    record && this.onRowDoubleClick(record, selectedRowIndex, event);
	                                    record && this.onHotKeyClose();
	                                }

	                                // onEnter 逻辑添加 by bbqin
	                                setTimeout(() => {
	                                    let target = td || this.referInput;
	                                    // 加一个isShow判断逻辑 弹窗关闭之后才可以跳转
	                                    let isShow = this.state.isShow;
	                                    let lifecycleStatus = this.lifecycleStatus;

	                                    if (executePopOverEnterSelect({ isShow, lifecycleStatus })) {
	                                        this.props.onEnter &&
												this.props.onEnter({ e: event, target, eventKey: 'Enter' });
	                                    }
	                                }, 20);
	                            }
	                        },
	                        up: () => {
	                            let { isAddButtonShow } = this.state;
	                            if (isAddButtonShow) {
	                                this.setState(({ currentButtonIndex }) => ({ currentButtonIndex: --currentButtonIndex }))
	                            } else {
	                                this.onTableKeyPress(true);
	                                if (document.activeElement === this.moreButton) {
	                                    this.setState({ isMoreButtonShow: false });
	                                }
	                            }
	                        },
	                        down: () => {
	                            let { isAddButtonShow } = this.state;
	                            if (isAddButtonShow) {
	                                this.setState(({ currentButtonIndex }) => ({ currentButtonIndex: ++currentButtonIndex }))
	                            } else {
	                                this.onTableKeyPress(false);
	                                if (document.activeElement === this.moreButton) {
	                                    if (this.state.isMoreButtonShow) {
	                                        this.moreButtonMenu && this.moreButtonMenu.focus();
	                                    }
	                                    this.setState({ isMoreButtonShow: true });
	                                }
	                            }
	                        },
	                        toUsual: () => {
	                            if (this.getStatus().isShowStatus && refType === 'gridTree' && isShowUsual) {
	                                this.setState(
	                                    { activeKey: '1' },
	                                    this.show.bind(this, true),
	                                );
	                                this.popWindow && this.popWindow.focus();
	                            }
	                        },
	                        toAll: () => {
	                            if (this.getStatus().isShowStatus && refType === 'gridTree' && isShowUsual) {
	                                this.setState(
	                                    { activeKey: '2' },
	                                    this.show.bind(this, true),
	                                );
	                                this.popWindow && this.popWindow.focus();
	                            }
	                        },
	                        pageLeft: () => {
	                            if (this.getStatus().isShowStatus && refType !== 'tree') {
	                                let { tableData } = this.state;
	                                let { page } = tableData[0];
	                                if (page) {
	                                    let newPage = --page.pageIndex;
	                                    newPage < 0 && (newPage = 0);
	                                    this.onPageChange(newPage + 1);
	                                }
	                            }
	                        },
	                        pageRight: () => {
	                            if (this.getStatus().isShowStatus && refType !== 'tree') {
	                                let { tableData } = this.state;
	                                let { page } = tableData[0];
	                                if (page) {
	                                    let newPage = ++page.pageIndex;
	                                    newPage > page.totalPage - 1 && (newPage = page.totalPage - 1);
	                                    this.onPageChange(newPage + 1);
	                                }
	                            }
	                        },
	                        batchSelectTableRow: () => {
	                            let isShowStatus = this.getStatus().isShowStatus;

	                            if (
	                                isShowStatus &&
									document.activeElement.contains(this.table) &&
									this.spaceKeyDown === true
	                            ) {
	                                let { selectedValues, selectedRowIndex, tableData } = this.state,
	                                    row = tableData[0].rows[selectedRowIndex];

	                                if (isMultiSelectedEnabled) {
	                                    this.toggleValueForMapOrObject(selectedValues, row.refpk, row);
	                                }

	                                this.setState({
	                                    isMultiSelectMode: true,
	                                    selectedValues,
	                                });
	                            }
	                        },
	                        spaceKeyUp: () => {
	                            this.spaceKeyDown = false;
	                            this.spaceKeyPress = false;
	                        },
	                        batchSelectTreeNode: () => {
	                            let isShowStatus = this.getStatus().isShowStatus;

	                            if (
	                                isShowStatus &&
									this.refTree &&
									this.refTree.contains(document.activeElement) &&
									this.spaceKeyDown === true
	                            ) {
	                                // this.pressOnTreeNode = false;
	                                this.setState(
	                                    { isMultiSelectMode: true },
	                                    () => {
	                                        this.selectTreeNodeWithBatch = true;
	                                        let checkboxEl = document.activeElement.parentElement.querySelector(
	                                            '.u-tree-checkbox',
	                                        );
	                                        checkboxEl && checkboxEl.click();
	                                        this.selectTreeNodeWithBatch = false;
	                                    },
	                                );
	                            }
	                        },
	                    }}
	                    attach={document.body}
	                    focused={true}
	                />
	            )}
	        </div>,
	        container,
	    );
	};

	// 复写原型方法：渲染弹出层头部
	renderPopoverHeader = () => {
	    const { refName, refName_db } = this.props; // 后台要加的
	    let { max } = this.state;
	    return [
	        <img className="refer-header-img" src={require('../../static/images/modal-img.png')} />,
	        <div className="refer-title cancel-drag" key="1" fieldid={getSysFieldid(`${refName_db || refName}_title`)}>
	            {refName_db || refName}
	        </div>,
	        <div className="refer-header-extend" key="2">
	            {this.renderPopoverHeaderExtend()}
	        </div>,
	        <Tooltip
	            placement="top"
	            overlay={this.state.jsonInsideRefer['containers-refer-refresh']}
	            delayHide={1}
	            delayShow={1000}
	        >
	            <div className="refer-refresh iconfont icon-shuaxin1 cancel-drag" onClick={this.refresh} key="3" />
	        </Tooltip>,
	        <Tooltip
	            placement="top"
	            overlay={max ? this.state.jsonInsideRefer['containers-refer-reduction'] : this.state.jsonInsideRefer['containers-refer-max']}
	            delayHide={1}
	            delayShow={1000}
	        >
	            <div
	                className={`refer-max iconfont ${max ? 'icon-zuixiaohua' : 'icon-zuidahua'} cancel-drag`}
	                onClick={() => {
	                    this.max();
	                }}
	                key="4"
	            />
	        </Tooltip>,
	        <Tooltip
	            placement="top"
	            overlay={this.state.jsonInsideRefer['containers-refer-close']}
	            delayHide={1}
	            delayShow={1000}
	        >
	            <div className="refer-close iconfont icon-guanbi cancel-drag" onClick={this.cancel} key="5" />
	        </Tooltip>,
	    ];
	};

	// 调用与【常用】相关的一系列接口
	usualAction = async (action, pk, index) => {
	    const { queryGridUrl, usualDataSize } = this.props;
	    let { selectedValues, tableData } = this.state;
	    let param = { queryCondition: { UsualActionURL: queryGridUrl } },
	        url;
	    switch (action) {
	        case 'save':
	            let data = await this.loadUsualData(false),
	                dataLength = data.rows.length,
	                totalLength = dataLength + this.getSelections().length;
	            if (totalLength > usualDataSize) {
	                toast({
	                    color: 'warning',
	                    content: this.state.jsonInsideRefer['containers-refer-0042']
	                        .replace('${0042-a}', totalLength - usualDataSize)
	                        .replace('${0042-b}', usualDataSize),
	                });
	                return;
	            } else {
	                url = SAVE_USUAL_URL;
	                param.queryCondition.UsualActionPks = [...selectedValues.keys()].join(',');
	            }
	            break;
	        case 'clear':
	            url = DELETE_USUAL_URL;
	            param.queryCondition.UsualActionPks = tableData[0].rows.map(e => e.refpk).join(',');
	            break;
	        case 'delete':
	            url = DELETE_USUAL_URL;
	            param.queryCondition.UsualActionPks = pk;
	            break;
	        default:
	            throw new Error("'action' expect 'save', 'clear', or 'delete'");
	    }
	    if (!param.queryCondition.UsualActionPks) {
	        // 您还没有选择数据
	        toast({ color: 'warning', content: this.state.jsonInsideRefer['containers-refer-0013'] });
	        return;
	    }
	    ajax({
	        url,
	        data: param,
	        loading: false,
	        success: res => {
	            if (res.success) {
	                if (action === 'delete') {
	                    selectedValues.delete(pk);
	                    tableData[0].rows.splice(index, 1);
	                } else if (action === 'clear') {
	                    tableData[0].rows.forEach(e => {
	                        selectedValues.delete(e.refpk);
	                    });
	                    tableData[0].rows = [];
	                }
	                this.setState({
	                    tableData,
	                    selectedValues,
	                    loading: false,
	                });
	                toast({ color: 'success', content: String(res.data || '') });
	            } else {
	                this.setState({ loading: false });
	                // throw new Error(res.error.message);
	            }
	        },
	        error: e => {
	            toast({ color: 'danger', content: e.message });
	            this.setState({ loading: false });
	            // throw new Error(e);
	        },
	    });
	};

	// 渲染：【全部 or 常用页签】
	renderTabs = key => {
	    let { activeKey } = this.state;
	    const { refType, isShowUsual, pageSize } = this.props;
	    return (
	        isShowUsual &&
			activeKey === key && (
	            <div className="refer-search-left-area" key="1">
	                {refType === 'gridTree' && (
	                    <div className="refer-left-tab">
	                        <Tabs
	                            tabIndex={this.getTabIndex(this.hotKeyElement.tabs)}
	                            activeKey={activeKey}
	                            onChange={k => {
	                                this.setState(
	                                    { 
	                                        activeKey: k,
	                                        tableData: [
	                                            {
	                                                rows: [],
	                                                page: {
	                                                    pageIndex: 0,
	                                                    pageSize,
	                                                    totalPage: 1,
	                                                },
	                                            },
	                                        ],
	                                    },
	                                    this.show.bind(this, true),
	                                );
	                            }}
	                        >
	                            {/* 常用 */}
	                            <TabPane tab={this.state.jsonInsideRefer['containers-refer-0014']} key="1" />
	                            {/* 全部 */}
	                            <TabPane tab={this.state.jsonInsideRefer['containers-refer-0015']} key="2" />
	                        </Tabs>
	                    </div>
	                )}
	            </div>
	        )
	    );
	};

	// 渲染：【搜索grid的搜索框】
	renderSearchTableInput = () => {
	    let { searchVal, columnConfig } = this.state;
	    let { name: names, search = {}, fullTxtCode } = columnConfig[0];
	    names = JSON.parse(JSON.stringify(names));
	    const {
	        refType,
	        refName,
	        refName_db, // 后台要加的
	        isShowTableSearch,
	        allowSearchConfig,
	    } = this.props;
	    let a = classNames({
	        'refer-search-table-input': true,
	        'refer-search-table-input-padding': refType == 'gridTree',
	    });
	    return (
	        refType !== 'tree' &&
			isShowTableSearch && (
	            <div className={a} key="2">
	                <FormControl
	                    className={`search-input ${GRID_TREE_SEARCH_INPUT}`}
	                    style={{ paddingRight: allowSearchConfig && 64 }}
	                    // 搜索
	                    placeholder={`${this.state.jsonInsideRefer['containers-refer-0016']?.replace('{1}', refName_db || refName)}`}
	                    value={searchVal}
	                    onClick={e => {
	                        let ncc_automated = getGlobalStorage('localStorage', '_ncc_automated_');
	                        if (ncc_automated == '1') {
	                            // 自动化测试开关打开
	                            let v = e.target.value;
	                            this.popSearchTable(v);
	                        }
	                    }}
	                    onChange={v => {
	                        this.setState({ searchVal: v });
	                        let ncc_automated = getGlobalStorage('localStorage', '_ncc_automated_');
	                        if (ncc_automated != '1') {
	                            // 自动化测试开关关闭
	                            this.interval = new Date().getTime();
	                            let s = setTimeout(() => {
	                                // 停止输入0.5s后执行
	                                if (new Date().getTime() - this.interval >= 500) {
	                                    this.popSearchTable(v);
	                                }
	                                clearTimeout(s);
	                            }, 500);
	                        }
	                    }}
	                    tabIndex={this.getTabIndex(this.hotKeyElement.tableSearchInput)}
	                    onKeyDown={this.resetHotKeyLoop.bind(this, this.hotKeyElement.tableSearchInput)}
	                    ref={dom => {
	                        this.searchTableInput = ReactDOM.findDOMNode(dom);
	                    }}
	                    fieldid={getSysFieldid('search')}
	                />
	                <Tooltip
	                    placement="top"
	                    overlay={this.state.jsonInsideRefer['containers-refer-search']}
	                    delayHide={1}
	                    delayShow={1000}
	                >
	                    <i className="refer-search-i iconfont icon-sousuo" />
	                </Tooltip>
	                {searchVal && (
	                    <Tooltip
	                        placement="top"
	                        overlay={this.state.jsonInsideRefer['containers-refer-clear']}
	                        delayHide={1}
	                        delayShow={1000}
	                    >
	                        <i
	                            className="refer-del-i iconfont icon-qingkong"
	                            style={{ marginRight: allowSearchConfig && 20 }}
	                            onClick={() => {
	                                this.popSearchTable('');
	                                this.setState({ searchVal: '' });
	                            }}
	                        />
	                    </Tooltip>
	                )}
	                {/* 搜索设置 */}
	                {/* {false && ( */}
	                {allowSearchConfig && (
	                    <Popover
	                        container={document.body}
	                        className="popover-in-refer popover-for-search-config"
	                        trigger="click"
	                        placement="bottom"
	                        content={
	                            <div
	                                fieldid={getSysFieldid('search-config_list')}
	                                className="refer-popover-container search-config"
	                            >
	                                <ul className="search-config-ul">
	                                    {columnConfig[0].code
	                                        .filter((e, i) => {
	                                            if (fullTxtCode && !fullTxtCode.hasOwnProperty(e)) {
	                                                names[i] = '';
	                                            }
	                                            return !(fullTxtCode && !fullTxtCode.hasOwnProperty(e));
	                                        })
	                                        .map((e, i) => {
	                                            names = names.filter(e => e);
	                                            let name = names[i];
	                                            return (
	                                                <li className="refer-search-config-item" title={e} key={e}>
	                                                    <Checkbox
	                                                        tabIndex="-1"
	                                                        checked={
	                                                            e === 'refname' ||
																e === 'refcode' ||
																(search || {})[e] ||
																(!(search || {}).hasOwnProperty(e) &&
																	fullTxtCode &&
																	fullTxtCode[e])
	                                                        }
	                                                        value={e}
	                                                        onClick={evt => {
	                                                            evt.stopPropagation();
	                                                            search[e] = !(search[e] === true);
	                                                            columnConfig[0].search = search;
	                                                            this.setState(
	                                                                { columnConfig },
	                                                                () => {
	                                                                    this.pushToColumnConfig();
	                                                                },
	                                                            );
	                                                        }}
	                                                        disabled={e === 'refname' || e == 'refcode'}
	                                                    >
	                                                        {name}
	                                                    </Checkbox>
	                                                </li>
	                                            );
	                                        })}
	                                </ul>
	                                <div className="refer-dnd-bottom">
	                                    <span className="to-default" onClick={this.resetColumnConfig}>
	                                        {/* 恢复默认 */}
	                                        {this.state.jsonInsideRefer['containers-refer-0005']}
	                                    </span>
	                                </div>
	                            </div>
	                        }
	                    >
	                        <Tooltip
	                            placement="top"
	                            overlay={this.state.jsonInsideRefer['containers-refer-setting']}
	                            delayHide={1}
	                            delayShow={1000}
	                        >
	                            <i className="search-setting iconfont icon-shezhi" style={{ display: 'block' }} />
	                        </Tooltip>
	                    </Popover>
	                )}
	            </div>
	        )
	    );
	};

	// 渲染：【显示停用】dom
	renderShowDisabledData = () => {
	    const { isShowDisabledData, isHasDisabledData } = this.props;
	    return (
	        isHasDisabledData &&
			isShowDisabledData && (
	            <Checkbox
	                className="include-children"
	                checked={this.state.isShowDisabledData}
	                disabled={this.state.isDisabledDataDisabled}
	                onClick={() => {
	                    this.setState(
	                        { isShowDisabledData: !this.state.isShowDisabledData },
	                        () => {
	                            this.show(true);
	                        },
	                    );
	                }}
	                tabIndex={this.getTabIndex(this.hotKeyElement.showDisabledData)}
	                onKeyDown={this.resetHotKeyLoop.bind(this, this.hotKeyElement.showDisabledData)}
	                ref={dom => {
	                    this.disableDataCheckbox = ReactDOM.findDOMNode(dom);
	                }}
	            >
	                {typeof isShowDisabledData === 'string' ? (
	                    isShowDisabledData
	                ) : (
	                // 显示停用
	                    this.state.jsonInsideRefer['containers-refer-0017']
	                )}
	            </Checkbox>
	        )
	    );
	};

	// 渲染：【包含下级】dom
	renderIncludeChildren = () => {
	    const { refType, isMultiSelectedEnabled, onlyLeafCanSelect, isTreelazyLoad } = this.props;
	    return (
	        isMultiSelectedEnabled &&
			refType === 'tree' &&
			!onlyLeafCanSelect &&
			!isTreelazyLoad && (
	            <Checkbox
	                className="include-children"
	                checked={this.state.includeChildren}
	                onClick={() => {
	                    // 点包含下级时，变为多选模式
	                    this.setState({
	                        includeChildren: !this.state.includeChildren,
	                        isMultiSelectMode: true,
	                    });
	                }}
	                tabIndex={this.getTabIndex(this.hotKeyElement.includeChildren)}
	                onKeyDown={this.resetHotKeyLoop.bind(this, this.hotKeyElement.includeChildren)}
	            >
	                {/* 包含下级 */}
	                {this.state.jsonInsideRefer['containers-refer-0018']}
	            </Checkbox>
	        )
	    );
	};

	selectLeaf = () => {
	    let { treeData } = this.state;
	    this.setState({
	        selectedValues: new Map(
	            treeData.filter(e => e.isleaf).map(e => [e.refpk, e]),
	        ),
	    });
	}

	selectSection = (start, end) => {
	    let { treeData } = this.state;
	    this.setState({
	        selectedValues: new Map(
	            treeData.filter(e => e.level >= start && e.level <= end).map(e => [e.refpk, e]),
	        ),
	    });
	}

	// 渲染：【更多按钮】dom
	renderMoreButton = (type) => {
	    let { treeData, selectLevel } = this.state;
	    const { isMultiSelectedEnabled, refType, idKey, isTreelazyLoad } = this.props;
	    if (!type && !(refType === 'tree' && !isTreelazyLoad)) {
	        return;
	    }
	    let maxLevel = Math.max(...treeData.map(e => e.level || 0)),
	        currentLevel,
	        arr = [...new Array(maxLevel)].map((e, i) => i + 1);

	    const menu = (
	        <Menu
	            keyboard
	            tabIndex={this.getTabIndex(this.hotKeyElement.moreButton)}
	            ref={dom => {
	                this.moreButtonMenu = ReactDOM.findDOMNode(dom);
	            }}
	            // vertical
	            onClick={({ key }) => {
	                this.moreButton && this.moreButton.focus();
	                this.setState({ isMoreButtonShow: false });
	                if (key === 'select-leaf') {
	                    this.selectLeaf();
	                } else if (key === 'expandAll') {
	                    this.setState({ expandedKeys: treeData.map(e => e[idKey]) });
	                } else if (key === 'unExpandAll') {
	                    this.setState({ expandedKeys: [] });
	                } else if (key && key.indexOf('expand') !== -1) {
	                    currentLevel = Number(key.split('expand')[1]);
	                    this.setState({ expandedKeys: treeData.filter(e => e.level <= currentLevel - 1).map(e => e[idKey]) });
	                } else if (key && key.indexOf('select') !== -1) {
	                    currentLevel = Number(key.split('select')[1]);
	                    this.setState({
	                        selectedValues: new Map(
	                            treeData.filter(e => e.level === currentLevel).map(e => [e.refpk, e]),
	                        ),
	                    });
	                }
	            }}
	        >
	            {/* 全部展开 */}
	            <Item key="expandAll" title={this.state.jsonInsideRefer['containers-refer-0006']}>
	                {this.state.jsonInsideRefer['containers-refer-0006']}
	            </Item>
	            {/* 全部收起 */}
	            <Item key="unExpandAll" title={this.state.jsonInsideRefer['containers-refer-0007']}>
	                {this.state.jsonInsideRefer['containers-refer-0007']}
	            </Item>
	            {/* 级次展开 */}
	            {!!arr.length && <SubMenu key="3" title={this.state.jsonInsideRefer['containers-refer-0008']}>
	                {arr.map(e => (
	                    <Item
	                        key={`expand${e}`}
	                        title={(this.state.jsonInsideRefer['containers-refer-0009'] || '').replace('${0009}', e)}
	                    >
	                        {/* 展开***级 */}
	                        {(this.state.jsonInsideRefer['containers-refer-0009'] || '').replace('${0009}', e)}
	                    </Item>
	                ))}
	            </SubMenu>}
	            {!!arr.length && !type && isMultiSelectedEnabled && (
	            // 级次选择
	                <SubMenu key="4" title={this.state.jsonInsideRefer['containers-refer-0010']}>
	                    {arr.map(e => (
	                        <Item
	                            key={`select${e}`}
	                            title={(this.state.jsonInsideRefer['containers-refer-0011'] || '')
	                                .replace('${0011}', e)}
	                        >
	                            {/* 选择***级 */}
	                            {(this.state.jsonInsideRefer['containers-refer-0011'] || '').replace('${0011}', e)}
	                        </Item>
	                    ))}
	                    <Item
	                        key={`select-leaf`}
	                        title={(this.state.jsonInsideRefer['containers-refer-0050'] || '')}
	                    >
	                        {/* 选择末级 */}
	                        {(this.state.jsonInsideRefer['containers-refer-0050'] || '')}
	                    </Item>
	                </SubMenu>
	            )}
	            {!!arr.length && !type  && isMultiSelectedEnabled && (
	            // 自定义级次选择
	                <SubMenu key="5" title={this.state.jsonInsideRefer['containers-refer-0049']}>
	                    <div className="custom-select">
	                        <div
	                            onMouseDown={e => {
	                                e.preventDefault();
	                                e.stopPropagation();
	                            }}
	                            onClick={e => {
	                                e.stopPropagation();
	                            }}
	                        >
	                            <div className="custom-select-panel">
	                                <div>
	                                    {/* 开始级次 */}
	                                    <div className="custom-select-from">{this.state.jsonInsideRefer['containers-refer-0051']}</div>
	                                    <div className="custom-select-level">
	                                        <ul>
	                                            {arr.map(level => <li
	                                                onClick={() => {
	                                                    selectLevel[0] = level;
	                                                    this.setState({ selectLevel })
	                                                }}
	                                                className={selectLevel[0] === level && 'custom-select-level-active'}
	                                            >{level}{this.state.jsonInsideRefer['containers-refer-0053']}</li>)}
	                                        </ul>
	                                    </div>
	                                </div>
	                                <div className="custom-select-middle-line"></div>
	                                <div>
	                                    {/* 结束级次 */}
	                                    <div className="custom-select-to">{this.state.jsonInsideRefer['containers-refer-0052']}</div>
	                                    <div className="custom-select-level">
	                                        <ul>
	                                            {arr.map(level => <li
	                                                onClick={() => {
	                                                    selectLevel[1] = level;
	                                                    this.setState({ selectLevel })
	                                                }}
	                                                className={selectLevel[1] === level && 'custom-select-level-active'}
	                                            >{level}{this.state.jsonInsideRefer['containers-refer-0053']}</li>)}
	                                        </ul>
	                                    </div>
	                                </div>
	                            </div>
	                            <div className="custom-select-button-area">
	                                <span
	                                    className="custom-select-sure"
	                                    onClick={() => {
	                                        if (selectLevel[0] > selectLevel[1]) {
	                                            toast({ color: 'danger', content: this.state.jsonInsideRefer['containers-refer-0054'] });
	                                        } else {
	                                            this.selectSection(...selectLevel)
	                                        }
	                                        this.setState({ isMoreButtonShow: false })
	                                    }}
	                                    // 确定
	                                >{this.state.jsonInsideRefer['containers-refer-0032']}</span>
	                                {/* <span 
										className="custom-select-cancel"
										onClick={() => {

										}}
										// 取消
									>{this.state.jsonInsideRefer['containers-refer-0033']}</span> */}
	                            </div>
	                        </div>
	                    </div>
	                </SubMenu>
	            )}
	        </Menu>
	    );
	    return (
	        <Popover
	            container={document.body}
	            className="popover-in-refer more"
	            trigger="click"
	            placement="bottom"
	            content={menu}
	            show={this.state.isMoreButtonShow}
	            // show={true}
	            fieldid="more_btn_menu"
	            onHide={(show) => {
	                // console.log('onhide', show);
					this.setState({ isMoreButtonShow: show });
	            }}
	        >
	            <span
	                className="more-button"
	                onClick={e => {
	                    e.stopPropagation();
	                    this.setState(({ isMoreButtonShow }) => ({ isMoreButtonShow: !isMoreButtonShow }));
	                }}
	                tabIndex={this.getTabIndex(this.hotKeyElement.moreButton)}
	                ref={dom => {
	                    this.moreButton = dom;
	                }}
	                onKeyDown={this.resetHotKeyLoop.bind(this, this.hotKeyElement.moreButton)}
	                onBlur={() => {
	                    // 点其他区域时关闭
	                    setTimeout(() => {
	                        this.setState({ isMoreButtonShow: false });
	                    }, 300);
	                }}
	            >
	                {/* 更多 */}
	                {this.state.jsonInsideRefer['containers-refer-0012']}
	            </span>
	        </Popover>
	    );
	};

	// 渲染：【设为常用】dom
	renderSetToUsual = () => {
	    let { activeKey } = this.state;
	    const { refType, isShowUsual } = this.props;
	    return (
	        isShowUsual &&
			refType === 'gridTree' && (
	            <Button
	                className={`set-to-usual ${activeKey == '1' ? 'clear' : ''}`}
	                onClick={this.usualAction.bind(this, activeKey == '1' ? 'clear' : 'save')}
	                fieldid={activeKey == '1' ? 'clear' : 'setusual'}
	            >
	                {activeKey == '1' ? (
	                // 清空
	                    this.state.jsonInsideRefer['containers-refer-0019']
	                ) : (
	                // 设为常用
	                    this.state.jsonInsideRefer['containers-refer-0020']
	                )}
	            </Button>
	        )
	    );
	};

	// 渲染：【列设置】的DOM
	renderColumnConfig = () => {
	    let { columnConfig } = this.state,
	        { name: names, code: codes, checked = {} } = columnConfig[0],
	        { allowColumnConfig, refType } = this.props;

	    if (!(allowColumnConfig && refType !== 'tree' && Array.isArray(names) && names.length > 3)) {
	        return;
	    }
	    const list = names.map((e, i) => {
	        let code = codes[i];
	        return (
	            <div name={e} code={code} key={code} fieldid={getSysFieldid(code)}>
	                <Checkbox
	                    onClick={evt => {
	                        evt.stopPropagation();
	                        checked[code] === false ? (checked[code] = true) : (checked[code] = false);
	                        columnConfig[0].checked = checked;
	                        this.setState(
	                            { columnConfig },
	                            () => {
	                                this.pushToColumnConfig();
	                            },
	                        );
	                    }}
	                    checked={(checked || {})[code] !== false}
	                >
	                    <span title={e}>{e}</span>
	                </Checkbox>
	                <span
	                    className={`refer-column-config-opt ${i === 0 && 'refer-column-config-disabled'}`}
	                    onClick={evt => {
	                        evt.stopPropagation();
	                        if (i !== 0) {
	                            columnConfig[0].name.splice(i, 1);
	                            columnConfig[0].code.splice(i, 1);
	                            columnConfig[0].name.unshift(e);
	                            columnConfig[0].code.unshift(code);
	                            this.setState(
	                                { columnConfig },
	                                () => {
	                                    this.pushToColumnConfig();
	                                },
	                            );
	                        }
	                    }}
	                >
	                    {/* 置顶 */}
	                    {this.state.jsonInsideRefer['containers-refer-0001']}
	                </span>
	                <span
	                    className={`refer-column-config-opt ${i === 0 && 'refer-column-config-disabled'}`}
	                    onClick={evt => {
	                        evt.stopPropagation();
	                        if (i !== 0) {
	                            columnConfig[0].name.splice(i, 1);
	                            columnConfig[0].code.splice(i, 1);
	                            columnConfig[0].name.splice(i - 1, 0, e);
	                            columnConfig[0].code.splice(i - 1, 0, code);
	                            this.setState(
	                                { columnConfig },
	                                () => {
	                                    this.pushToColumnConfig();
	                                },
	                            );
	                        }
	                    }}
	                >
	                    {/* 上移 */}
	                    {this.state.jsonInsideRefer['containers-refer-0002']}
	                </span>
	                <span
	                    className={`refer-column-config-opt ${i === codes.length - 1 &&
							'refer-column-config-disabled'}`}
	                    onClick={evt => {
	                        evt.stopPropagation();
	                        if (i !== codes.length - 1) {
	                            columnConfig[0].name.splice(i, 1);
	                            columnConfig[0].code.splice(i, 1);
	                            columnConfig[0].name.splice(i + 1, 0, e);
	                            columnConfig[0].code.splice(i + 1, 0, code);
	                            this.setState(
	                                { columnConfig },
	                                () => {
	                                    this.pushToColumnConfig();
	                                },
	                            );
	                        }
	                    }}
	                >
	                    {/* 下移 */}
	                    {this.state.jsonInsideRefer['containers-refer-0003']}
	                </span>
	                <span
	                    className={`refer-column-config-opt ${i === codes.length - 1 &&
							'refer-column-config-disabled'}`}
	                    onClick={evt => {
	                        evt.stopPropagation();
	                        if (i !== codes.length - 1) {
	                            columnConfig[0].name.splice(i, 1);
	                            columnConfig[0].code.splice(i, 1);
	                            columnConfig[0].name.push(e);
	                            columnConfig[0].code.push(code);
	                            this.setState(
	                                { columnConfig },
	                                () => {
	                                    this.pushToColumnConfig();
	                                },
	                            );
	                        }
	                    }}
	                >
	                    {/* 置底 */}
	                    {this.state.jsonInsideRefer['containers-refer-0004']}
	                </span>
	            </div>
	        );
	    });
	    return (
	        <Popover
	            className="popover-in-refer"
	            trigger="click"
	            placement="bottomRight"
	            container={document.body}
	            content={
	                <div className="refer-popover-container" fieldid={getSysFieldid('column-config_list')}>
	                    <div style={{ flex: '1 1 auto', overflow: 'auto' }}>
	                        <Dnd
	                            dragClass="refer-column-config-item"
	                            dropClass="refer-dnd refer-column-config-list"
	                            list={list}
	                            onStop={(drag, list) => {
	                                if (list) {
	                                    columnConfig[0].name = list.map(e => e.props.name);
	                                    columnConfig[0].code = list.map(e => e.props.code);
	                                    this.setState(
	                                        { columnConfig },
	                                        () => {
	                                            this.pushToColumnConfig();
	                                        },
	                                    );
	                                }
	                            }}
	                            fieldid="column-config_list"
	                        />
	                    </div>
	                    <div className="refer-dnd-bottom">
	                        <span className="to-default" onClick={this.resetColumnConfig}>
	                            {/* 恢复默认 */}
	                            {this.state.jsonInsideRefer['containers-refer-0005']}
	                        </span>
	                    </div>
	                </div>
	            }
	        >
	            <Tooltip
	                placement="top"
	                overlay={this.state.jsonInsideRefer['containers-refer-column-setting']}
	                delayHide={1}
	                delayShow={1000}
	            >
	                <div className="refer-column-config" key="5">
	                    <span fieldid={getSysFieldid('shezhi_btn')}>
	                        <i className="column-config iconfont icon-shezhi" />
	                    </span>
	                </div>
	            </Tooltip>
	        </Popover>
	    );
	};

	// 复写原型方法：渲染弹出层搜索区域
	renderPopoverSearchArea = () => {
	    return [
	        // 全部 or 常用页签
	        this.renderTabs('1'),
	        // 搜索表的搜索框
	        this.renderSearchTableInput(),
	        // 显示停用
	        this.renderShowDisabledData(),
	        // 树形参照是否包含下级
	        this.renderIncludeChildren(),
	        // 树形参照的更多按钮
	        this.renderMoreButton(),
	        // 搜索区域扩展区
	        <div className="refer-search-area-extend" key="4">
	            {this.renderPopoverSearchExtendArea()}
	        </div>,
	        // 设为常用
	        this.renderSetToUsual(),
	        // 列设置
	        this.renderColumnConfig(),
	    ];
	};

	// 复写原型方法：渲染弹出层内容区
	renderPopoverContain = () => {
	    const { refType, attrcode, fieldid } = this.props;
	    let treeWidth = this.getReferTreeConfig();
	    let { activeKey, max, isExpandLeftArea, referContentAreaHeight, resizeHeight } = this.state;
	    let contentAreaHeight = referContentAreaHeight + resizeHeight + 'px';

	    return refType === 'gridTree' && activeKey == 1 ? (
	    // 常用
	        <Row
	            className="refer-content-area"
	            style={{ width: '100%', flexDirection: 'column', height: contentAreaHeight }}
	        >
	            {this.renderPopoverRight()}
	        </Row>
	    ) : (
	        <Row className="refer-content-area" style={{ height: contentAreaHeight }}>
	            {refType !== 'grid' &&
						refType !== 'gridTree' && (
	                <div
	                    style={{ width: refType === 'tree' ? '100%' : isExpandLeftArea ? '100%' : treeWidth }}
	                    fieldid={getSysFieldid(`${fieldid || attrcode}_tree-area`)}
	                    className={`refer-tree ${isExpandLeftArea ? 'expand' : ''}`}
	                >
	                    {this.renderPopoverLeft()}
	                </div>
	            )}
	            {/* { refType === 'gridTree' && <div className="refer-expand-left" onClick={this.toggleExpandLeftArea} /> } */}
	            {refType !== 'tree' &&
						refType !== 'gridTree' && (
	                <div
	                    style={{ width: isExpandLeftArea ? '0px' : max ? 'auto' : refType === 'grid' ? '640px' : '780px' }}
	                    className={`refer-grid  ${isExpandLeftArea ? 'expand' : ''}`}
	                >
	                    <div className="refer-table">{this.renderPopoverRight()}</div>
	                </div>
	            )}
	            {refType === 'gridTree' && (
	                <DragWidthCom
	                    leftDom={
	                        // drag  修改为 继承父元素的

	                        <div
	                            style={{ width: refType === 'tree' ? '100%' : isExpandLeftArea ? '100%' : '100%' }}
	                            fieldid={getSysFieldid(`${fieldid || attrcode}_tree-area`)}
	                            className={`refer-tree ${isExpandLeftArea ? 'expand' : ''}`}
	                        >
	                            {this.renderPopoverLeft()}
	                        </div>
	                    }
	                    defLeftWid={treeWidth}
	                    onDragStop={width => {
	                        this.pushToReferTreeConfig(width);
	                        this.forceUpdate();
	                    }}
	                    rightDom={
	                        // refType === 'gridTree' && <div className="refer-expand-left" onClick={this.toggleExpandLeftArea} />
	                        // drag  修改为 继承父元素的
	                        <div
	                            style={{
	                                width: isExpandLeftArea
	                                    ? '0px'
	                                    : max ? 'auto' : refType === 'grid' ? '640px' : '100%',
	                            }}
	                            className={`refer-grid  ${isExpandLeftArea ? 'expand' : ''}`}
	                        >
	                            <div className="refer-table">{this.renderPopoverRight()}</div>
	                        </div>
	                    }
	                />
	            )}
	        </Row>
	    );
	};

	/**
	 * 判断一下树的根节点是否需要选中
	 */
	shouldCheckedRootNode = (treeData, selectedValues, rootNode, idKey) => {
	    // console.log('shouldCheckedRootNode', idKey);
	    if (!rootNode || !selectedValues || !treeData) {
	        return null;
	    }
	    let svl = selectedValues.size || 0;
	    // 去除禁用的元素 数据过大可能会有问题
	    let tl = treeData.filter(e => !this.isDisabled(e)).length;

	    svl = selectedValues.has(rootNode[idKey]) ? svl - 1 : svl;
	    if (svl > 0 && tl > 0 && svl >= tl - 1) {
	        // selectedValues.set(rootNode[idKey], rootNode);
	        return 'all';
	    } else {
	        selectedValues.delete(rootNode[idKey]);
	        if (selectedValues.size > 0) {
	            return 'indeterminate';
	        }
	        return null;
	    }
	};

	// 复写原型方法：渲染弹出层左侧
	renderPopoverLeft = () => {
	    let {
	        selectedKeys,
	        expandedKeys,
	        selectedValues,
	        treeData,
	        treeSearchVal,
	        isTreeSearch,
	        treeDataWithChildren,
	        keyMap,
	    } = this.state;
	    const {
	        refType,
	        isMultiSelectedEnabled,
	        isTreelazyLoad,
	        rootNode,
	        onlyLeafCanSelect,
	        idKey,
	        pidKey,
	        isShowTreeSearch,
	        isShowUsual,
	        fieldValued,
	        fieldid,
	        attrcode,
			gridTreeShowMoreButton
	    } = this.props;
	    let search = this.renderPopoverSearchArea();
	    // 判断根节点 是否应该选中 by bbqin
	    this.shouldCheckedRoot = this.shouldCheckedRootNode(treeData, selectedValues, rootNode, idKey);

	    let checkedKeys = [...selectedValues.values()].map(e => e[idKey] || e[fieldValued])
	    if (this.shouldCheckedRoot === 'all') {
	        checkedKeys = [...new Set(checkedKeys.concat(rootNode[idKey]))];
	    }

	    return [
	        // 全部 or 常用页签
	        this.renderTabs('2'),
	        /* 搜索树的搜索框 */
	        refType !== 'grid' && (
	            <div
	                className={`refer-tree-header  ${refType === 'gridTree' && isShowUsual && ' refer-tree-header-bb'}`}
	            >
	                {isShowTreeSearch && (
	                    <div className={`refer-search-table-input ${refType === 'gridTree' && gridTreeShowMoreButton && ' refer-tree-gridTree-input'}`}>
	                        <FormControl
	                            className="search-input"
	                            type="text"
	                            // 搜索
	                            placeholder={`${this.state.jsonInsideRefer[
	                                'containers-refer-0016'
	                            ]?.replace('{1}', rootNode.refname)}`}
	                            value={treeSearchVal}
	                            onClick={e => {
	                                let ncc_automated = getGlobalStorage('localStorage', '_ncc_automated_');
	                                if (ncc_automated == '1') {
	                                    // 自动化测试开关打开
	                                    let v = e.target.value
	                                    this.popSearchTree(v);
	                                }
	                            }}
	                            onChange={v => {
	                                this.setState({ treeSearchVal: v });
	                                let ncc_automated = getGlobalStorage('localStorage', '_ncc_automated_');
	                                if (ncc_automated != '1') {
	                                    // 自动化测试开关关闭
	                                    this.interval = new Date().getTime();
	                                    let s = setTimeout(() => {
	                                        // 停止输入0.5s后执行
	                                        if (new Date().getTime() - this.interval >= 500) {
	                                            this.popSearchTree(v);
	                                        }
	                                        clearTimeout(s);
	                                    }, 500);
	                                }
	                            }}
	                            tabIndex={this.getTabIndex(this.hotKeyElement.treeSearchInput)}
	                            onKeyDown={this.resetHotKeyLoop.bind(this, this.hotKeyElement.treeSearchInput)}
	                            ref={dom => {
	                                this.searchTreeInput = ReactDOM.findDOMNode(dom);
	                            }}
	                            fieldid={getSysFieldid('search')}
	                        />
	                        <i className="refer-search-i iconfont icon-sousuo" />
	                        {treeSearchVal && (
	                            <i
	                                className="refer-del-i iconfont icon-qingkong"
	                                onClick={() => {
	                                    this.popSearchTree('');
	                                    this.setState({ treeSearchVal: '' });
	                                }}
	                            />
	                        )}
	                    </div>
	                )}
	                {refType === 'tree' && search}
					{refType === 'gridTree' && this.renderMoreButton(gridTreeShowMoreButton)}
	            </div>
	        ),
	        this.renderPopoverLeftHeader(),
	        <div className="refer-tree-wrapper" fieldid={getSysFieldid(`${fieldid || attrcode}_tree`)}>
	            <div
	                className={`refer-tree-container ${this.shouldCheckedRoot === 'indeterminate'
	                    ? 'refer-tree-indeterminate'
	                    : ''}`}
	                onKeyDown={isIE() && this.controlTabSequenceInIE}
	            >
	                <ArrayTree
	                    checkable={refType === 'tree' && isMultiSelectedEnabled}
	                    data={[...treeData.values()]}
	                    onSelect={this.onTreeNodeSelect}
	                    onDoubleClick={this.onTreeNodeDoubleClick}
	                    onExpand={this.onTreeNodeExpand}
	                    onCheck={this.onTreeNodeCheck}
	                    checkedKeys={checkedKeys}
	                    selectedKeys={selectedKeys}
	                    expandedKeys={expandedKeys}
	                    isTreelazyLoad={isTreelazyLoad}
	                    root={rootNode}
	                    onlyLeafCanSelect={onlyLeafCanSelect}
	                    id={idKey}
	                    pid={pidKey}
	                    isTreeSearch={isTreeSearch}
	                    treeDataWithChildren={treeDataWithChildren}
	                    keyMap={keyMap}
	                    tabIndexValue={this.getTabIndex(this.hotKeyElement.referTree)}
	                    // onKeyDown={this.resetHotKeyLoop.bind(this, this.hotKeyElement.referTree)}
	                    // keyDown 事件 回调
	                    keyFun={e => {
	                        if ([e.keyCode, e.which, e.charCode].find(e => e === 13) || e.key === 'Enter') {
	                            e.stopPropagation();
	                        }

	                        if (e.repeat === true && e.keyCode === 32) {
	                            this.pressOnTreeNode = true;
	                        }
	                    }}
	                    ref={dom => {
	                        this.refTree = ReactDOM.findDOMNode(dom);
	                    }}
	                    onFocus={this.onTreeFocus}
	                    autoSelectWhenFocus={refType === 'gridTree'} //快捷键上下键移动时触发树的onSelect函数
	                    treeSearchKey={treeSearchVal} // tree 搜索高亮 关键字
	                />
	            </div>
	        </div>,
	    ];
	};

	// 复写原型方法：渲染弹出层右侧
	renderPopoverRight = () => {
	    const { refType, rowKey, attrcode, fieldid, columnConfig, pageSize, useAllSelect } = this.props;
	    let { tableData, activeKey, isFirstShow, isShow, tableScrollHeight, resizeHeight, selectedKeys, searchVal, selectedValues, jsonInsideRefer } = this.state,
	        { sort } = columnConfig[0],
	        columns = [],
	        // scrollTop = this.scrollTop || this.scrollTop === 0 ? this.scrollTop : -1,
	        search = this.renderPopoverSearchArea(),
	        pageArea = this.renderPopoverPageArea();
	    // delete this.scrollTop;
	    // columns.length = 0;
	    columns.push({
	        // 序号
	        title: (
	            <span
	                fieldid={getSysFieldid('numberindex')}
	                title={this.state.jsonInsideRefer['containers-refer-0021']}
	            >
	                {this.state.jsonInsideRefer['containers-refer-0021']}
	            </span>
	        ), // 序号列
	        key: '__index__',
	        width: '60px',
	        fixed: 'left',
	        render: (text, row, index) => {
	            return <span fieldid={getSysFieldid('numberindex')}>{index + 1}</span>;
	        },
	    });
	    this.props.isMultiSelectedEnabled &&
			columns.unshift({
			    title: (
			        <label className="refer-table-label">
			            <span className="checkbox-column" fieldid={getSysFieldid('firstcol')}>
			                <Checkbox
			                    onChange={this.checkAll}
			                    checked={this.isAllChecked()}
			                    tabIndex={40}
			                    // 增加一个中间态
			                    indeterminate={this.isIndeterminated()}
			                    className={TABLE_HEAD_CHECKBOX_CLASS_NAME}
			                    onKeyDown={this.handleTableHeadCheckboxKeyDown}
			                    onKeyUp={this.preventDefaultTableCheckbox}
			                />
			                {useAllSelect && <Dropdown
			                    overlayClassName="refer-all-select"
			                    trigger={['click']}
			                    overlay={<ul>
			                        <li 
			                            onClick={() => {
			                                let data;
			                                if (activeKey == 1) {
			                                    data = tableData[0].rows;
			                                } else {
			                                    data = this.loadTableDataSync(this.__getParam({
			                                        pageInfo: { pageIndex: -1 },
			                                        pid: selectedKeys[0],
			                                        keyword: searchVal,
			                                    }))?.rows || [];
			                                }

			                                data.forEach(row => selectedValues.set(row.refpk, row));
			                                this.setState({ selectedValues });
			                            }}
			                        >
			                            {/* 全选 */}
			                            {jsonInsideRefer['containers-refer-0059']}
			                            {this.isRealAllChecked() && <i className="iconfont icon-liucheng1"></i>}
			                        </li>
			                        {/* <li 
			                            onClick={this.checkCurrentPage}
			                        > */}
			                            {/* 仅当前页 */}
			                            {/* {jsonInsideRefer['containers-refer-0060']}
			                            {this.isCurrentAllChecked() && <i className="iconfont icon-liucheng1"></i>}
			                        </li> */}
			                        <li 
			                            onClick={() => {
			                                this.setState({ selectedValues: new Map() });
			                            }}
			                        >
			                            {/* 全消 */}
			                            {jsonInsideRefer['containers-refer-0061']}
			                        </li>
			                    </ul>}
			                >
			                    <i className="iconfont icon-xiajiantou"></i>
			                </Dropdown>}
			            </span>
			        </label>
			    ), // 全选效果
			    key: '__checkbox__',
			    width: '60px',
			    fixed: 'left',
			    render: (text, row, index) => {
			        return (
			            <label className="refer-table-label">
			                <span fieldid={getSysFieldid('firstcol')}>
			                    <Checkbox
			                        onClick={e => {
			                            let { selectedValues, isMultiSelectMode } = this.state;
			                            e.stopPropagation();
			                            this.toggleValueForMapOrObject(selectedValues, row.refpk, row);
			                            isMultiSelectMode || this.onRowClick(row, index, e);
			                            this.setState({
			                                isMultiSelectMode: true,
			                                selectedValues,
			                            });
			                        }}
			                        checked={!!this.state.selectedValues.get(row.refpk)}
			                        tabIndex="-1"
			                    />
			                </span>
			            </label>
			        );
			    },
			});

	    columns.push(...this.getCommonColumns());
	    // 【常用】页签时，增加【移除】列
	    if (activeKey == '1') {
	        columns.push({
	            // 操作
	            title: (
	                <span fieldid={getSysFieldid('opr')}>{this.state.jsonInsideRefer['containers-refer-0022']}</span>
	            ), // 全选效果
	            key: '__opt__',
	            width: '100px',
	            fixed: 'right',
	            render: (text, row, index) => {
	                return (
	                    <span
	                        className="refer-del"
	                        fieldid={getSysFieldid('opr')}
	                        onClick={e => {
	                            e.stopPropagation();
	                            this.usualAction('delete', row.refpk, index);
	                        }}
	                        onDoubleClick={e => {
	                            // 阻止双击表格行的事件，防止参照关闭
	                            e.stopPropagation();
	                        }}
	                    >
	                        {/* 移除 */}
	                        {this.state.jsonInsideRefer['containers-refer-0023']}
	                    </span>
	                );
	            },
	        });
	    }

	    let emptyText = this.haveNoData ? {} : { emptyText: () => '' };

	    // 以下各种判断为了满足UI的“设计”
	    return [
	        search && (
	            <div
	                className={`refer-search ${refType === 'gridTree' && ' refer-search-bc'}`}
	                style={{
	                    padding: refType === 'grid' ? '0 17px' : '0 20px 0 0',
	                    // borderBottom: refType === 'gridTree' ? '1px solid #d0d0d0' : 'none' // 使用className控制
	                }}
	                ref={dom => {
	                    this.referSearchDom = dom;
	                }}
	                fieldid={getSysFieldid('search-area')}
	            >
	                {isFirstShow || search}
	            </div>
	        ),
	        <div
	            className={`refer-grid ${refType === 'gridTree' ? ' refer-grid-blf' : ''}`}
	            style={{
	                padding: refType === 'grid' ? '0 20px' : '0',
	                // borderLeft: refType === 'gridTree' ? '1px solid #dbdbdb' : 'none' // 转化为className
	            }}
	            ref={dom => {
	                this.referTable = dom;
					// tinper升级后dom u-table-content 多了1px出现误差
	                if (isShow && dom && dom.offsetHeight - tableRowHeight !== tableScrollHeight) {
	                    this.setState({ tableScrollHeight: dom ? dom.offsetHeight - tableRowHeight : 0 });
	                }
	            }}
	            fieldid={getSysFieldid(`${fieldid || attrcode}_table`)}
	        >
	            <div className={`refer-table selectable-${attrcode}`}>
	                {this.props.isMultiSelectedEnabled && (
	                    <Selectable
	                        canvas={`.selectable-${attrcode}`}
	                        // 注意可以加下前后空格
	                        selector=" tbody tr "
	                        unitKey="refpk"
	                        disabled={!this.props.isMultiSelectedEnabled || 'slide'} // 可选值 true false 'shift' 'ctrl' 'slide'
	                        userSelect={true} // 启用用户文字选中
	                        unitsData={tableData[0].rows}
	                        // 开始项  主要配合外部的 单选事件处理 以及初始化时的  shift 操作
	                        // 如果设置为空  内部会根据dom查找一次  但是dom还没渲染  可能会有问题
	                        startItem={tableData[0].rows[0] && tableData[0].rows[0]['refpk']}
	                        onSelect={(d, type) => {
	                            console.log(type);
	                            let data = tableData[0].rows,
	                                rowLen = data.length;
	                            if (rowLen > 0) {
	                                let { selectedValues } = this.state;
	                                data.forEach(element => {
	                                    let refpk = element['refpk'];
	                                    if (d[refpk]) {
	                                        selectedValues.set(refpk, element);
	                                    }
	                                    if (!d[refpk] && selectedValues.get(refpk)) {
	                                        selectedValues.delete(refpk);
	                                    }
	                                });
	                                this.setState({ selectedValues });
	                            }
	                        }}
	                    />
	                )}
	                <Table
	                    lazyload={pageSize > 50}
	                    height={tableRowHeight}
	                    headerHeight={tableRowHeight}
	                    onRowClick={this.onRowClick}
	                    onRowDoubleClick={this.onRowDoubleClick}
	                    rowKey={record => this.getDisplayOrValue(record, rowKey)}
	                    columns={columns}
	                    data={tableData[0].rows}
	                    scroll={{
	                        y: tableScrollHeight + resizeHeight + 'px',
	                        x: true,
	                    }}
	                    rowClassName={this.rowClassName}
	                    bodyStyle={{ height: tableScrollHeight + resizeHeight + 'px' }}
	                    focusable
	                    tabIndex={this.getTabIndex(this.hotKeyElement.referTable)}
	                    // onKeyDown={this.resetHotKeyLoop.bind(this, this.hotKeyElement.referTable)}
	                    ref={dom => {
	                        this.table = ReactDOM.findDOMNode(dom);
	                    }}
	                    // scrollTop={scrollTop}
	                    addBlankCol={false}
	                    customSort={sort}
	                    {...emptyText}
	                />
	            </div>
	        </div>,
	        // 常用页签不分页
	        activeKey == '2' &&
			pageArea && (
	            <div fieldid={getSysFieldid(`${fieldid || attrcode}_table`)}>
	                <div
	                    // 行内样式模式  迁移为class模式
	                    fieldid={getSysFieldid('pagination-div')}
	                    className={`refer-page ${refType === 'gridTree' ? 'refer-page-gridtree' : ''}`}
	                    // style={{
	                    // 	borderLeft: refType === 'gridTree' ? '1px solid #dbdbdb' : 'none'
	                    // }}
	                >
	                    {pageArea}
	                </div>
	            </div>
	        ),
	    ];
	};

	handleTableHeadCheckboxKeyDown = e => {
	    let { tableData } = this.state,
	        tableBody = this.table && this.table.querySelector('.u-table-body'),
	        len = tableData[0].rows.length - 1;
	    if (e.keyCode === 38 || e.keyCode === 40) {
	        e.keyCode === 38
	            ? selectToLastRow.call(this, { tableDataLen: len, tableBody })
	            : selectToFirstRow.call(this);

	        //为了onTableKeyPress中的此判断条件 document.activeElement === this.table 把this.table设为聚焦状态
	        this.table.focus();
	    }

	    if (e.keyCode === 32 && this.spaceKeyPress !== true) {
	        e.target && e.target.click();
	    }
	};

	preventDefaultTableCheckbox = e => {
	    /*
		* checkbox space键 keyup时才触发选中效果，但UE要求space键按下时就触发选中效果,
		* 因此keyDown时执行选中效果，keyup时阻止默认行为
		*/
	    e.preventDefault();
	};

	// 复写原型方法：渲染弹出层分页区
	renderPopoverPageArea = () => {
	    let { tableData } = this.state;
	    const { refType } = this.props;
	    let { page } = tableData[0];
	    if (refType === 'tree') {
	        return null;
	    }
	    return (
	        page &&
			Number(page.totalPage) > 1 && [
	            <div className="refer-totalpage" key="1">
	                {/* 共99条 */}
	            </div>,
	            <div className="refer-page-extend" key="2" />,
	            <div className="refer-pagination" key="3">
	                <Pagination
	                    ncHotKeyboard={false}
	                    prev
	                    next
	                    boundaryLinks
	                    items={Number(page.totalPage) || 1}
	                    maxButtons={5}
	                    gap={true}
	                    activePage={Number(page.pageIndex) + 1}
	                    onSelect={this.onPageChange}
	                />
	            </div>,
	        ]
	    );
	};

	onPageChange = newPage => {
	    let { tableData, selectedKeys, isSearch, searchVal } = this.state,
	        { rootNode, pageSize } = this.props;
	    tableData[0].page.pageIndex = String(newPage - 1);
	    // 根据页码重新查数据
	    this.setState(
	        { tableData },
	        () => {
	            this.referTable && (this.referTable.querySelector('.u-table-body').scrollTop = 0);
	            this.loadAndSetTableData({
	                pid: selectedKeys[0] === rootNode.refpk ? '' : selectedKeys[0] || '',
	                pageInfo: tableData[0].page,
	                keyword: isSearch ? searchVal : '',
	                filterPks: newPage !== 1 && (this.allpks || []).slice((newPage - 1) * pageSize, newPage * pageSize),
	            });
	        },
	    );
	};

	// 复写原型方法：渲染弹出层底部
	renderPopoverBottom = () => {
	    let { selectedShow, addButtonList, isAddButtonShow, currentButtonIndex } = this.state,
	        selectColumns = [];
	    const { isMultiSelectedEnabled, refType, isRunWithChildren, hasAddButton, isQuerySelectedData } = this.props;
	    selectColumns.push({
	        // 操作
	        title: <span fieldid={getSysFieldid('opr')}> {this.state.jsonInsideRefer['containers-refer-0025']} </span>,
	        key: 'operate',
	        width: 100,
	        fixed: 'right',
	        render: (text, row, index) => {
	            return (
	                <span
	                    fieldid={getSysFieldid('opr')}
	                    className="refer-del"
	                    onClick={this.onSelectedRowClick.bind(null, row, index)}
	                >
	                    {/* 移除 */}
	                    {this.state.jsonInsideRefer['containers-refer-0026']}
	                </span>
	            );
	        },
	    });

	    selectColumns.unshift(...this.getCommonColumns(selectedShow));

	    return [
	        isMultiSelectedEnabled && (
	            <div className="refer-selected" key="1">
	                <Button
	                    fieldid="selected"
	                    onClick={() => {
	                        !selectedShow && isQuerySelectedData && this.loadSelectedData();
	                        this.setState({ selectedShow: !selectedShow });
	                    }}
	                >
	                    {/* 已选 */}
	                    {`${this.state.jsonInsideRefer['containers-refer-0027']}:（${this.getSelections().length}）`}
	                </Button>
	                
	            </div>
	        ),
	        // 树形参照是否执行时包含下级
	        // isMultiSelectedEnabled &&
	        refType === 'tree' &&
			// !onlyLeafCanSelect &&
			isRunWithChildren && (
	            <Checkbox
	                className="include-children"
	                checked={this.state.runWithChildren}
	                onClick={() => {
	                    this.setState({ runWithChildren: !this.state.runWithChildren });
	                }}
	                tabIndex={this.getTabIndex(this.hotKeyElement.runWithChildren)}
	            >
	                {/* 执行时包含下级 */}
	                {this.state.jsonInsideRefer['containers-refer-0031']}
	            </Checkbox>
	        ),
	        <div className="refer-bottom-extend" key="2">
	            {this.renderPopoverBottomExtend()}
	        </div>,
	        <div className="buttons" key="3">
	            {(() => {
	                if (hasAddButton && Array.isArray(addButtonList)) {
	                    switch (addButtonList.length) {
	                        case 0:
	                            return null;
	                        case 1:
	                            return <Tooltip
	                                placement="top"
	                                inverse
	                                overlay={`${this.state.jsonInsideRefer['containers-refer-0046']}  (${NCHotKeys.USUAL_KEYS
	                                    .ADD})`}
	                                trigger={['hover', 'focus']}
	                                className="model-helper-overlay"
	                            >
	                                <Button onClick={() => {
	                                    let { appcode, pagecode } = addButtonList[0];
	                                    pageTo.openTo(null, {
	                                        appcode,
	                                        pagecode,
	                                        status: 'browse',
	                                    })
	                                }}>
	                                    {/* 新增 */}
	                                    {this.state.jsonInsideRefer["containers-refer-0046"]}
										(<span className="text-decoration-underline">/</span>)
	                                </Button>
	                            </Tooltip>;
	                        default:
	                            let length = addButtonList.length
	                            return <Popover
	                                container={this.popWindow}
	                                className="popover-in-refer add"
	                                trigger="click"
	                                placement="bottom"
	                                content={<div className="add-button-wrapper">{addButtonList.map(({ name, appcode, pagecode }, i) => {
	                                    return <div className={`add-button-item ${(currentButtonIndex % length + length) % length === i ? 'selected' : ''}`} key={name} onClick={() => {
	                                        pageTo.openTo(null, {
	                                            appcode,
	                                            pagecode,
	                                            status: 'browse',
	                                        })
	                                    }}>{name}</div>;
	                                })}</div>}
	                                fieldid="more_btn_menu"
	                                show={isAddButtonShow}
	                                onVisibleChange={isAddButtonShow => {
	                                    this.setState({ isAddButtonShow })
	                                }}
	                            >
	                                <Tooltip
	                                    placement="top"
	                                    inverse
	                                    overlay={`${this.state.jsonInsideRefer['containers-refer-0046']}  (${NCHotKeys.USUAL_KEYS
	                                        .ADD})`}
	                                    trigger={['hover', 'focus']}
	                                    className="model-helper-overlay"
	                                >

	                                    <Button onClick={() => {
	                                        this.setState(({ isAddButtonShow }) => ({ isAddButtonShow: !isAddButtonShow }))
	                                    }}>
	                                        {/* 新增 */}
	                                        {this.state.jsonInsideRefer["containers-refer-0046"]}
												(<span className="text-decoration-underline">/</span>)
	                                        <i className="iconfont icon-hangcaozuoxiala1"></i>
	                                    </Button>
	                                </Tooltip>
	                            </Popover>
	                    }
	                }
	            })()}
	            <Tooltip
	                placement="top"
	                inverse
	                overlay={`${this.state.jsonInsideRefer['containers-refer-0032']}  (${NCHotKeys.USUAL_KEYS
	                    .MODAL_CONFIRM})`}
	                trigger={['hover', 'focus']}
	                className="model-helper-overlay"
	            >
	                <Button
	                    onClick={this.handleSureButtonClick}
	                    className="sure-btn"
	                    fieldid="sure"
	                    disabled={this.isSureButtonDisabled()}
	                >
	                    {/* 确定 */}
	                    {this.state.jsonInsideRefer['containers-refer-0032']}(
	                    <span className="text-decoration-underline">Y</span>
						)
	                </Button>
	            </Tooltip>
	            <Tooltip
	                placement="top"
	                inverse
	                overlay={`${this.state.jsonInsideRefer['containers-refer-0033']}  (${NCHotKeys.USUAL_KEYS
	                    .MODAL_CALCEL})`}
	                trigger={['hover', 'focus']}
	                className="model-helper-overlay"
	            >
	                <Button onClick={this.handleCancelButtonClick} className="cancel-btn" fieldid="cancel">
	                    {/* 取消 */}
	                    {this.state.jsonInsideRefer['containers-refer-0033']}(
	                    <span className="text-decoration-underline">N</span>
						)
	                </Button>
	            </Tooltip>
	        </div>,
	    ];
	};

	isSureButtonDisabled = () => {
	    let { refType, isMultiSelectedEnabled } = this.props,
	        { selectedValues } = this.state;
	    return refType === 'tree' && !isMultiSelectedEnabled && this.isDisabled([...selectedValues.values()][0] || {});
	};

	handleSureButtonClick = () => {
	    let { isMultiSelectedEnabled } = this.props;
	    isMultiSelectedEnabled ? this.multiSelect() : this.singleSelect(this.getSelections()[0]);
	    this.handlePopoverBlur();
	};

	handleCancelButtonClick = () => {
	    this.cancel();
	};

	/**
	 * @param e {object} 事件源
	 * @param direction {string} 拖动方向
	 * @param ref {dom} 拖动的元素
	 * @param d {object} 移动偏移量
	 * @note 请不要删除onResize里参数里的事件源对象
	 */
	onResize(e, direction, ref, d) {
	    // if (direction === 'topLeft' || direction === 'topRight') return;
	    let { resizePosition } = this.state;

	    /* resize 之前的值 */
	    let originX = resizePosition.x;
	    let originY = resizePosition.y;

	    /* 移动的位移 */
	    let moveW = d.width;
	    let moveH = d.height;
	    let refHeight = parseFloat(ref.style.height);
	    let refMinHeight = parseFloat(ref.style.minHeight);
	    /* 移动的位移 */
	    let x = null;
	    let y = null;

	    /* 处理左边缘 */
	    if (/left/i.test(direction)) {

	        x = originX - moveW;
	        y = originY;
	        this.position = { x, y };
	    } else if (/top/i.test(direction)) {
	        /* 处理上边缘 */

	        x = originX;
	        y =
				refHeight === refMinHeight || refHeight < refMinHeight
				    ? parseFloat(ref.style.transform.split(',')[1])
				    : originY - moveH;
	        this.position = { x, y };
	    } else {
	        this.position = null;
	    }

	    if (resizeOnVertical(direction)) {
	        if (parseFloat(ref.style.height) < parseFloat(ref.style.minHeight) && direction === 'top') {
	            return;
	        }

	        d.height !== this.state.resizeHeight &&
				this.setState({ resizeHeight: d.height });
	    }

	    if (x || y) {
	        ref.style.transform = `translate(${x}px, ${y}px)`;
	    }
	}

	/**
	 * @desc: 窗口改变大小结束后重新给弹窗内容与table设置高度
	 */
	onResizeStop(e, direction, ref, d) {
	    let { top } = ref.getBoundingClientRect();
	    let a = ref.style.transform.replace(/(-?\d+.?\d+)px\)/, (a, p1) => {
	        return Number(p1) - top + 'px)';
	    });
	    if (top < 0) {
	        ref.style.transform = a;
	        this.position && (this.position.y -= top)
	    }

	    if (this.position) {
	        this.setState({ resizePosition: this.position });
	    }

	    if (resizeOnVertical(direction)) {
	        let { tableScrollHeight, referContentAreaHeight } = this.state;

	        this.setState({
	            tableScrollHeight: tableScrollHeight + d.height,
	            referContentAreaHeight: referContentAreaHeight + d.height,
	            resizeHeight: 0,
	        });
	    }
	}

	onDragStart() {
	    this.state.dragStartPosition !== null &&
			this.setState({ dragStartPosition: null });
	    // 清空一些状态
	    this.state.isMoreButtonShow === true &&
			this.setState({ isMoreButtonShow: false });
	}

	onDragStop = (e, draggableData) => {
	    modalAlwaysShowInView.call(this, e, draggableData);
	};

	/**
	 * @desc IE中gridTree类型参照中在树节点中点tab直接跳转到了地址搜索栏中所以IE浏览器特殊控制一下顺序
	 * @params e {object}
	 */
	controlTabSequenceInIE = e => {
	    let { refType } = this.props;
	    if (e.key === 'Tab' && refType === 'gridTree') {
	        let searchInput = this.referSearchDom && this.referSearchDom.querySelector(`.${GRID_TREE_SEARCH_INPUT}`);
	        e.stopPropagation();
	        e.preventDefault();
	        /**
			 * 不添加定时器不聚焦
			 * https://stackoverflow.com/questions/2600186/focus-doesnt-work-in-ie
			 */
	        let timer = setTimeout(() => {
	            searchInput && searchInput.focus();
	            clearTimeout(timer);
	        }, 100);
	    }
	};
}
